/* tslint:disable:no-duplicate-string */ // reason: creating functions to create mock data is preferred.

import moment from 'moment';
import {MetaData, MetaDataInterface} from '../components/ext-interface/model/meta-data.model';
import {OsrMetaData} from '../components/ext-interface/model/osr-meta-data.model';
import {RwsMetaData} from '../components/ext-interface/model/rws-meta-data.model';
import {FeatureMetadata} from '../components/sensor/model/feature-metadata.model';
import {FeatureType} from '../components/sensor/model/feature-type.model';
import {Feature} from '../components/sensor/model/feature.model';
import {Sensor} from '../components/sensor/model/sensor.model';
import {SensorSummary} from '../components/sensor/overview/model/sensor-overview.model';
import {Device} from '../shared/iot-platform/model/iot-device';
import {paginationObject} from '../shared/ui/pagination/model/object/pagination.sample.object';
import {PaginationProperties} from '../shared/ui/pagination/model/pagination.properties';
import {TableProperties} from '../shared/ui/table/model/table-properties.model';

export let mockObservations: any = {
  content: [
    {
      id: '9BBF4D55-D60C-49A3-8DBD-2808C210139F',
      phenomenonTime: '2017-12-15T15:45:06.545+0000',
      resultTime: '2017-12-15T15:45:12.967+0000',
      value: 58.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'FC14EAB8-B143-4A95-9B2D-F8FF6DA85CD2',
      phenomenonTime: '2017-12-15T15:44:56.496+0000',
      resultTime: '2017-12-15T15:45:02.973+0000',
      value: 57.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'FC1E759C-D11D-457B-87B9-2841DCCC3C2F',
      phenomenonTime: '2017-12-15T15:44:46.447+0000',
      resultTime: '2017-12-15T15:44:52.818+0000',
      value: 57.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '9D45627D-CEC3-4671-9832-51D15E6C693C',
      phenomenonTime: '2017-12-15T15:44:36.398+0000',
      resultTime: '2017-12-15T15:44:42.594+0000',
      value: 58.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1D0E2756-77F1-4E30-AD5E-B2BE78C56C55',
      phenomenonTime: '2017-12-15T15:44:26.350+0000',
      resultTime: '2017-12-15T15:44:32.656+0000',
      value: 59.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '01124FFA-96DB-42D5-95E7-C9A8B6A9BB63',
      phenomenonTime: '2017-12-15T15:44:16.301+0000',
      resultTime: '2017-12-15T15:44:22.788+0000',
      value: 58.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D4B0DF30-E394-4674-A51D-5A7F44F0374C',
      phenomenonTime: '2017-12-15T15:44:06.252+0000',
      resultTime: '2017-12-15T15:44:12.783+0000',
      value: 59.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1B8E0184-A0D2-4F38-8DEB-1515FE1E178E',
      phenomenonTime: '2017-12-15T15:43:56.203+0000',
      resultTime: '2017-12-15T15:44:02.773+0000',
      value: 59.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '872A3EDA-BA1C-4804-98B5-57E15B8CB0A4',
      phenomenonTime: '2017-12-15T15:43:46.154+0000',
      resultTime: '2017-12-15T15:43:52.727+0000',
      value: 58.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'F25C0C56-1CDC-4570-B589-B655BC102854',
      phenomenonTime: '2017-12-15T15:43:36.106+0000',
      resultTime: '2017-12-15T15:43:42.296+0000',
      value: 59.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D12B6A2B-86C8-41CE-8925-F9737F7229D3',
      phenomenonTime: '2017-12-15T15:43:26.056+0000',
      resultTime: '2017-12-15T15:43:32.225+0000',
      value: 60.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '101DB31B-2250-4D27-A867-39CD7644EBA8',
      phenomenonTime: '2017-12-15T15:43:16.007+0000',
      resultTime: '2017-12-15T15:43:22.214+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '3A035C91-8F03-4A71-B99C-AC6C293D9D65',
      phenomenonTime: '2017-12-15T15:43:05.959+0000',
      resultTime: '2017-12-15T15:43:12.211+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'C8C61A6F-3FCE-4708-893C-934728D9467A',
      phenomenonTime: '2017-12-15T15:42:55.910+0000',
      resultTime: '2017-12-15T15:43:02.345+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '05F15CC5-BC13-476B-976B-B4B9E31CCEC0',
      phenomenonTime: '2017-12-15T15:42:45.861+0000',
      resultTime: '2017-12-15T15:42:52.373+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '482AC8E1-BC37-4989-9E88-B233EDCE1E3B',
      phenomenonTime: '2017-12-15T15:42:35.812+0000',
      resultTime: '2017-12-15T15:42:42.003+0000',
      value: 64.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'CEA546E2-4B51-418D-9C9F-B2CB17001785',
      phenomenonTime: '2017-12-15T15:42:25.763+0000',
      resultTime: '2017-12-15T15:42:32.012+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D71963D9-B594-4E77-939B-E70D6FFD7640',
      phenomenonTime: '2017-12-15T15:42:15.715+0000',
      resultTime: '2017-12-15T15:42:21.980+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '7EC6BEF8-E4CA-4DE6-BBDF-47176EB32377',
      phenomenonTime: '2017-12-15T15:42:05.666+0000',
      resultTime: '2017-12-15T15:42:12.010+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '88956E84-ED29-46E3-9CB1-3A9BF0E8E249',
      phenomenonTime: '2017-12-15T15:41:55.617+0000',
      resultTime: '2017-12-15T15:42:01.821+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '751E86F8-C514-4C42-9440-FB683E976FD2',
      phenomenonTime: '2017-12-15T15:41:45.568+0000',
      resultTime: '2017-12-15T15:41:52.024+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '0C3524CB-92A9-4E20-B0E4-CB3EE2D248D2',
      phenomenonTime: '2017-12-15T15:41:35.519+0000',
      resultTime: '2017-12-15T15:41:41.920+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D2D87608-B98D-4E66-9936-7622B9D0E4FD',
      phenomenonTime: '2017-12-15T15:41:25.470+0000',
      resultTime: '2017-12-15T15:41:31.647+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'ACE8F906-B630-44E5-8D52-CE1771CBCB4E',
      phenomenonTime: '2017-12-15T15:41:15.421+0000',
      resultTime: '2017-12-15T15:41:21.286+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'BBDBA6AA-8CE0-43E8-A04A-C143149885B4',
      phenomenonTime: '2017-12-15T15:41:05.372+0000',
      resultTime: '2017-12-15T15:41:11.581+0000',
      value: 60.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '03A232FD-8BBB-4983-9AFF-C6AE35B88AED',
      phenomenonTime: '2017-12-15T15:40:55.323+0000',
      resultTime: '2017-12-15T15:41:01.588+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'A95DD5F2-4AFD-4E19-B319-7203643DCB52',
      phenomenonTime: '2017-12-15T15:40:45.274+0000',
      resultTime: '2017-12-15T15:40:51.539+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'F8E766D7-5B2A-44C5-BC64-20C6FFB4F31A',
      phenomenonTime: '2017-12-15T15:40:35.226+0000',
      resultTime: '2017-12-15T15:40:41.521+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'AE92C4A9-EB2A-4FF9-B690-13A4B18AC054',
      phenomenonTime: '2017-12-15T15:40:25.177+0000',
      resultTime: '2017-12-15T15:40:31.821+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'F14D9762-411E-4C3E-AAA0-EE1F5E5678CE',
      phenomenonTime: '2017-12-15T15:40:15.128+0000',
      resultTime: '2017-12-15T15:40:21.925+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'CA56E58D-85A1-4061-9962-8BD512152B9F',
      phenomenonTime: '2017-12-15T15:40:05.079+0000',
      resultTime: '2017-12-15T15:40:11.351+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'FA0CE1D7-2E21-47C5-93FA-9933384E12CB',
      phenomenonTime: '2017-12-15T15:39:55.030+0000',
      resultTime: '2017-12-15T15:40:01.338+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'EB85883E-3F3B-4352-85ED-968C88B55CCB',
      phenomenonTime: '2017-12-15T15:39:44.982+0000',
      resultTime: '2017-12-15T15:39:51.295+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'A4FB6647-7989-4CE4-9C24-1E0DEAD57BDF',
      phenomenonTime: '2017-12-15T15:39:34.932+0000',
      resultTime: '2017-12-15T15:39:41.290+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '339E32B7-4A2F-4360-890E-2E69BA95C9F2',
      phenomenonTime: '2017-12-15T15:39:24.884+0000',
      resultTime: '2017-12-15T15:39:31.276+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'CBB60E48-6E66-4A9C-A761-B15229922A66',
      phenomenonTime: '2017-12-15T15:39:14.835+0000',
      resultTime: '2017-12-15T15:39:22.104+0000',
      value: 59.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '17566E45-CCA9-49AA-8CFA-D13D414249F7',
      phenomenonTime: '2017-12-15T15:39:04.786+0000',
      resultTime: '2017-12-15T15:39:10.903+0000',
      value: 60.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'EC571463-A9D2-465B-8402-93AD8C99F0D9',
      phenomenonTime: '2017-12-15T15:38:54.737+0000',
      resultTime: '2017-12-15T15:39:00.985+0000',
      value: 60.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '77B84410-208D-4981-B10C-9A04056EC0AB',
      phenomenonTime: '2017-12-15T15:38:44.688+0000',
      resultTime: '2017-12-15T15:38:50.960+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '70F47AFC-4E92-4051-81B5-2685E0D7A819',
      phenomenonTime: '2017-12-15T15:38:34.640+0000',
      resultTime: '2017-12-15T15:38:40.969+0000',
      value: 61.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '3749CEC1-CFC2-45CE-BCE2-9964CAA44A02',
      phenomenonTime: '2017-12-15T15:38:24.590+0000',
      resultTime: '2017-12-15T15:38:30.954+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '3527BEA8-537E-4C47-8BFB-D538E44596CB',
      phenomenonTime: '2017-12-15T15:38:14.543+0000',
      resultTime: '2017-12-15T15:38:20.713+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'C7A5508B-BFE0-4835-8300-64B9E94300E0',
      phenomenonTime: '2017-12-15T15:38:04.493+0000',
      resultTime: '2017-12-15T15:38:10.691+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'DB66FEA5-E656-48B1-AE71-4ADDBA1CED0D',
      phenomenonTime: '2017-12-15T15:37:54.444+0000',
      resultTime: '2017-12-15T15:38:00.684+0000',
      value: 64.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4CA3E699-95B1-4E86-AAAD-EF48A6502051',
      phenomenonTime: '2017-12-15T15:37:44.395+0000',
      resultTime: '2017-12-15T15:37:50.631+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '645CFD08-67BC-4327-9E01-DF48AC571D7C',
      phenomenonTime: '2017-12-15T15:37:34.346+0000',
      resultTime: '2017-12-15T15:37:40.596+0000',
      value: 64.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '8DD83983-EE0F-4F93-9769-7CC799D7705B',
      phenomenonTime: '2017-12-15T15:37:24.297+0000',
      resultTime: '2017-12-15T15:37:30.583+0000',
      value: 64.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E9E6C427-9C62-4511-9F7C-689041EDFB31',
      phenomenonTime: '2017-12-15T15:37:14.248+0000',
      resultTime: '2017-12-15T15:37:20.518+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '640E62ED-B44F-4A16-AF59-758C54243E7A',
      phenomenonTime: '2017-12-15T15:37:04.200+0000',
      resultTime: '2017-12-15T15:37:10.465+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '3DDCCC97-53E1-4E35-8BAF-3F194AA2BEBA',
      phenomenonTime: '2017-12-15T15:36:54.151+0000',
      resultTime: '2017-12-15T15:37:00.453+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '51CC989C-93C5-43F9-8610-B5177F2DF339',
      phenomenonTime: '2017-12-15T15:36:44.102+0000',
      resultTime: '2017-12-15T15:36:50.344+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '63BDB628-1AE6-46DC-A9B2-FD63388D7BD9',
      phenomenonTime: '2017-12-15T15:36:34.053+0000',
      resultTime: '2017-12-15T15:36:40.339+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'CC5F001F-26F9-4C30-8158-EC8F416ABBFC',
      phenomenonTime: '2017-12-15T15:36:24.004+0000',
      resultTime: '2017-12-15T15:36:30.327+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'F1560D9E-C4D4-4655-BAB6-8E9F6903FA55',
      phenomenonTime: '2017-12-15T15:36:13.955+0000',
      resultTime: '2017-12-15T15:36:20.301+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'F2F680CC-34F5-44A3-A815-589C989AB739',
      phenomenonTime: '2017-12-15T15:36:03.907+0000',
      resultTime: '2017-12-15T15:36:10.291+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'B06B8A79-FEC3-4801-B18E-6E0F021DAA32',
      phenomenonTime: '2017-12-15T15:35:53.858+0000',
      resultTime: '2017-12-15T15:36:00.010+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '12087930-F456-46CF-A016-BF0A433429A4',
      phenomenonTime: '2017-12-15T15:35:43.809+0000',
      resultTime: '2017-12-15T15:35:50.224+0000',
      value: 62.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'ADF788C2-662C-4F05-B0FC-76107A710DB0',
      phenomenonTime: '2017-12-15T15:35:33.760+0000',
      resultTime: '2017-12-15T15:35:39.407+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'CD1D3770-4DF6-4830-A2BA-E15D4F6DE76E',
      phenomenonTime: '2017-12-15T15:35:23.711+0000',
      resultTime: '2017-12-15T15:35:30.211+0000',
      value: 63.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '9550B602-85F7-42DD-8DD3-727B359251F5',
      phenomenonTime: '2017-12-15T15:35:13.662+0000',
      resultTime: '2017-12-15T15:35:20.186+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '6676A423-398C-4345-AB58-976E305F4507',
      phenomenonTime: '2017-12-15T15:35:03.613+0000',
      resultTime: '2017-12-15T15:35:09.889+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'AE83691D-19DD-4A24-BB56-5B95F16ADF58',
      phenomenonTime: '2017-12-15T15:34:53.564+0000',
      resultTime: '2017-12-15T15:34:59.966+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '5F58C7DC-D55A-40E2-B7F0-A4BB3A411FC5',
      phenomenonTime: '2017-12-15T15:34:43.516+0000',
      resultTime: '2017-12-15T15:34:49.916+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '8F35A590-3AD3-4AC4-BC3D-EFC881FDCFC4',
      phenomenonTime: '2017-12-15T15:34:33.467+0000',
      resultTime: '2017-12-15T15:34:39.893+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '8B4CD7E1-8F9B-4372-9780-CE5E36D84C6F',
      phenomenonTime: '2017-12-15T15:34:23.418+0000',
      resultTime: '2017-12-15T15:34:29.864+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E5AE1822-4523-4993-A00D-7A76B9E1954A',
      phenomenonTime: '2017-12-15T15:34:13.369+0000',
      resultTime: '2017-12-15T15:34:19.847+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '13BE2854-1BF0-464D-8AA4-F929E2074650',
      phenomenonTime: '2017-12-15T15:34:03.320+0000',
      resultTime: '2017-12-15T15:34:09.795+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '5D686172-3B05-4318-BF23-8F4B42771A9E',
      phenomenonTime: '2017-12-15T15:33:53.271+0000',
      resultTime: '2017-12-15T15:33:59.768+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '5BD06E58-1BAF-4546-B8FF-057820E7DB06',
      phenomenonTime: '2017-12-15T15:33:43.222+0000',
      resultTime: '2017-12-15T15:33:49.447+0000',
      value: 66.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '8752E943-F8E9-4761-B2EE-BE3969DA4EFC',
      phenomenonTime: '2017-12-15T15:33:33.174+0000',
      resultTime: '2017-12-15T15:33:39.487+0000',
      value: 66.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '036946FD-38BD-4FFD-91F3-D9B4C6D1A955',
      phenomenonTime: '2017-12-15T15:33:23.125+0000',
      resultTime: '2017-12-15T15:33:29.018+0000',
      value: 66.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '155AC02B-C51A-44B8-8DF2-2F15A6BBBF99',
      phenomenonTime: '2017-12-15T15:33:13.076+0000',
      resultTime: '2017-12-15T15:33:19.275+0000',
      value: 67.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'FC537E44-6C57-4662-8FE3-70EDC5916081',
      phenomenonTime: '2017-12-15T15:33:03.027+0000',
      resultTime: '2017-12-15T15:33:09.511+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '18EFA3BA-9874-4160-B6D3-A8BE97F8C6BB',
      phenomenonTime: '2017-12-15T15:32:52.978+0000',
      resultTime: '2017-12-15T15:32:59.212+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'C1554EE1-F2C1-48A1-A937-899D032F8E04',
      phenomenonTime: '2017-12-15T15:32:42.929+0000',
      resultTime: '2017-12-15T15:32:49.162+0000',
      value: 70.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E8CD3FB3-EB4E-45D6-B938-02DEEC944198',
      phenomenonTime: '2017-12-15T15:32:32.880+0000',
      resultTime: '2017-12-15T15:32:39.386+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1D7C8BC3-E4A4-4853-B87D-5080EC7E245A',
      phenomenonTime: '2017-12-15T15:32:22.832+0000',
      resultTime: '2017-12-15T15:32:29.162+0000',
      value: 68.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'F677893C-181B-4D12-9757-E1E6F8EF0A44',
      phenomenonTime: '2017-12-15T15:32:12.783+0000',
      resultTime: '2017-12-15T15:32:19.118+0000',
      value: 67.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '3D9FB0A0-83A2-41EA-A665-B032C08FFBC4',
      phenomenonTime: '2017-12-15T15:32:02.734+0000',
      resultTime: '2017-12-15T15:32:09.098+0000',
      value: 66.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '81E9B863-97C4-4F5C-93C7-59463E8789C7',
      phenomenonTime: '2017-12-15T15:31:52.685+0000',
      resultTime: '2017-12-15T15:31:59.044+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '7DFD50EB-CB26-4B85-8229-17152ECD68F7',
      phenomenonTime: '2017-12-15T15:31:42.637+0000',
      resultTime: '2017-12-15T15:31:48.996+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '0241B469-F76D-4D3C-B8FE-0843ED6B37C3',
      phenomenonTime: '2017-12-15T15:31:32.587+0000',
      resultTime: '2017-12-15T15:31:38.977+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '7AD21CA3-4473-4572-88E9-473948245D4A',
      phenomenonTime: '2017-12-15T15:31:22.538+0000',
      resultTime: '2017-12-15T15:31:28.956+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '000CCBB9-38C4-40E3-B815-A8CE36ACDA91',
      phenomenonTime: '2017-12-15T15:31:12.489+0000',
      resultTime: '2017-12-15T15:31:18.889+0000',
      value: 65.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '2C433431-DFE1-4445-B030-423BB569AD27',
      phenomenonTime: '2017-12-15T15:31:02.440+0000',
      resultTime: '2017-12-15T15:31:08.852+0000',
      value: 66.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '5D2F8B2B-1CC7-442C-992A-9D5D3C44C2C7',
      phenomenonTime: '2017-12-15T15:30:52.392+0000',
      resultTime: '2017-12-15T15:30:58.834+0000',
      value: 67.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1907BA0A-BEBF-45A2-B518-7724404D46EB',
      phenomenonTime: '2017-12-15T15:30:42.343+0000',
      resultTime: '2017-12-15T15:30:48.757+0000',
      value: 68.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '7B0D4F50-C534-4876-870C-11074ECC0EB7',
      phenomenonTime: '2017-12-15T15:30:32.294+0000',
      resultTime: '2017-12-15T15:30:38.725+0000',
      value: 68.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1F630E9E-839B-4847-AAD2-91FE660ED749',
      phenomenonTime: '2017-12-15T15:30:22.246+0000',
      resultTime: '2017-12-15T15:30:28.511+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4AB96388-C85C-4241-9263-000D997BD7FC',
      phenomenonTime: '2017-12-15T15:30:12.197+0000',
      resultTime: '2017-12-15T15:30:18.902+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '14617D0D-891D-4666-962F-B7484E277259',
      phenomenonTime: '2017-12-15T15:30:02.148+0000',
      resultTime: '2017-12-15T15:30:08.325+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '69DEBB7C-31AF-42B3-9BE6-3EA34ACC931E',
      phenomenonTime: '2017-12-15T15:29:52.099+0000',
      resultTime: '2017-12-15T15:29:58.595+0000',
      value: 68.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '8F413C2A-00EA-4EE1-897C-6741751DC530',
      phenomenonTime: '2017-12-15T15:29:42.050+0000',
      resultTime: '2017-12-15T15:29:48.272+0000',
      value: 70.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '931C1207-9896-4F8E-888A-BBAB46963B23',
      phenomenonTime: '2017-12-15T15:29:32.001+0000',
      resultTime: '2017-12-15T15:29:38.137+0000',
      value: 70.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E79831DD-7D69-4F73-90F7-EBE4ED09A4F0',
      phenomenonTime: '2017-12-15T15:29:21.952+0000',
      resultTime: '2017-12-15T15:29:28.263+0000',
      value: 70.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'B4A3360F-4639-491F-9F8B-8E82380BB539',
      phenomenonTime: '2017-12-15T15:29:11.903+0000',
      resultTime: '2017-12-15T15:29:19.021+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1DB70D50-E821-46E8-8CFA-CEAF26AAF4F6',
      phenomenonTime: '2017-12-15T15:29:01.854+0000',
      resultTime: '2017-12-15T15:29:08.230+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'DB71E815-E9BC-405A-BB58-C3C6DFC25853',
      phenomenonTime: '2017-12-15T15:28:51.806+0000',
      resultTime: '2017-12-15T15:28:58.179+0000',
      value: 68.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '295C84DC-EDD7-4678-AF3F-BEE2774CDBB3',
      phenomenonTime: '2017-12-15T15:28:41.757+0000',
      resultTime: '2017-12-15T15:28:48.145+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '151C1940-ED37-4006-A24B-6E12821E21AC',
      phenomenonTime: '2017-12-15T15:28:31.708+0000',
      resultTime: '2017-12-15T15:28:39.651+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H',
      datum: 'NAP',
      uom: 'cm',
    },
    {
      id: 'C1C8F267-A382-4834-A5BF-F6B805ECCB6B',
      phenomenonTime: '2017-12-15T15:40:00.000+0000',
      resultTime: '2017-12-15T15:45:12.956+0000',
      value: 61.4666666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '36887A34-30DB-4C1D-BD1B-F9BC6AF6740D',
      phenomenonTime: '2017-12-15T15:30:00.000+0000',
      resultTime: '2017-12-15T15:35:09.877+0000',
      value: 68.3166666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D83B5700-776B-4565-913D-7EEBE8B236B6',
      phenomenonTime: '2017-12-15T15:20:00.000+0000',
      resultTime: '2017-12-15T15:25:07.120+0000',
      value: 72.7796610169491,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '0EEF5283-BDA6-4986-8D4C-389DCAF587A9',
      phenomenonTime: '2017-12-15T15:10:00.000+0000',
      resultTime: '2017-12-15T15:15:13.968+0000',
      value: 79.7,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'EAF0312C-60F8-4351-AE07-D2D348EC7495',
      phenomenonTime: '2017-12-15T15:00:00.000+0000',
      resultTime: '2017-12-15T15:05:11.236+0000',
      value: 85.0333333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'A4A1E4A4-FFC3-4E3B-AD08-52E4DEB16785',
      phenomenonTime: '2017-12-15T14:50:00.000+0000',
      resultTime: '2017-12-15T14:55:08.230+0000',
      value: 90.5106382978723,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '79F2256B-C478-42C7-897F-C8507CAED4C0',
      phenomenonTime: '2017-12-15T14:50:00.000+0000',
      resultTime: '2017-12-15T14:55:08.223+0000',
      value: 90.6779661016949,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '58F03824-9438-4D16-BE66-7F0CB1061A5B',
      phenomenonTime: '2017-12-15T14:40:00.000+0000',
      resultTime: '2017-12-15T14:45:15.222+0000',
      value: 95.5833333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'DDF3E168-C44B-4ED4-82E9-92F156E7CDE9',
      phenomenonTime: '2017-12-15T14:30:00.000+0000',
      resultTime: '2017-12-15T14:35:12.495+0000',
      value: 100.416666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'DBF0BD1A-5065-4F73-BA01-80215C4A6502',
      phenomenonTime: '2017-12-15T14:20:00.000+0000',
      resultTime: '2017-12-15T14:25:09.561+0000',
      value: 105.8,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '9B812755-30E6-4AB7-B06F-93D27FE667E6',
      phenomenonTime: '2017-12-15T14:10:00.000+0000',
      resultTime: '2017-12-15T14:15:06.591+0000',
      value: 109.64406779661,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '02169436-09A2-4146-B111-89C3DB3BB5F4',
      phenomenonTime: '2017-12-15T14:00:00.000+0000',
      resultTime: '2017-12-15T14:05:13.678+0000',
      value: 114.75,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '075A8568-1C22-4DCE-A6ED-F5B7D57075AB',
      phenomenonTime: '2017-12-15T13:50:00.000+0000',
      resultTime: '2017-12-15T13:55:10.704+0000',
      value: 119.916666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'AE6FEA8D-A754-4388-9961-5CF569BEF9B4',
      phenomenonTime: '2017-12-15T13:40:00.000+0000',
      resultTime: '2017-12-15T13:45:07.786+0000',
      value: 125.881355932203,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '40348218-45F9-4250-B3A9-615AE72D44FF',
      phenomenonTime: '2017-12-15T13:30:00.000+0000',
      resultTime: '2017-12-15T13:35:14.999+0000',
      value: 130.483333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'FF1881B5-37A8-4A9E-B2D6-5C6CF4F094B7',
      phenomenonTime: '2017-12-15T13:20:00.000+0000',
      resultTime: '2017-12-15T13:25:12.083+0000',
      value: 135.483333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '007AD4AB-1B4F-4797-A3CA-8634750212C7',
      phenomenonTime: '2017-12-15T13:10:00.000+0000',
      resultTime: '2017-12-15T13:15:09.047+0000',
      value: 139.305084745763,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D18D83C5-57E7-4569-B29B-373D70FDEDE3',
      phenomenonTime: '2017-12-15T13:00:00.000+0000',
      resultTime: '2017-12-15T13:05:16.193+0000',
      value: 142.666666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'F7B06BA2-A1E7-46EA-95C5-53EE3FC35999',
      phenomenonTime: '2017-12-15T12:50:00.000+0000',
      resultTime: '2017-12-15T12:55:13.223+0000',
      value: 145.866666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4A12FCAF-B175-48F8-919A-16D2D3411A03',
      phenomenonTime: '2017-12-15T12:40:00.000+0000',
      resultTime: '2017-12-15T12:45:10.428+0000',
      value: 145.733333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '449B1F16-B24A-4CD0-A482-29EE22A84D6E',
      phenomenonTime: '2017-12-15T12:30:00.000+0000',
      resultTime: '2017-12-15T12:35:07.277+0000',
      value: 144.864406779661,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '7A4FCE8C-A9EB-449E-BE68-9C2533351E54',
      phenomenonTime: '2017-12-15T12:20:00.000+0000',
      resultTime: '2017-12-15T12:25:14.506+0000',
      value: 140.133333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'ADB0725D-8B58-4CAC-9D9D-0C3E8C8875B3',
      phenomenonTime: '2017-12-15T12:10:00.000+0000',
      resultTime: '2017-12-15T12:15:12.336+0000',
      value: 133.65,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '9003B577-C4BF-40BF-A1FB-DA3126571679',
      phenomenonTime: '2017-12-15T12:00:00.000+0000',
      resultTime: '2017-12-15T12:05:08.624+0000',
      value: 127.203389830508,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '38AEA1E8-C054-4437-B163-4BBCD7F726A8',
      phenomenonTime: '2017-12-15T11:50:00.000+0000',
      resultTime: '2017-12-15T11:55:15.685+0000',
      value: 113.316666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '5E5C53D8-1306-4AF3-9F5A-FB3699938871',
      phenomenonTime: '2017-12-15T11:40:00.000+0000',
      resultTime: '2017-12-15T11:45:12.875+0000',
      value: 101.083333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '2E0EE937-C7C3-481B-A855-EC99E63A2C5A',
      phenomenonTime: '2017-12-15T11:30:00.000+0000',
      resultTime: '2017-12-15T11:35:09.863+0000',
      value: 88.65,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '3773E8C8-CD23-4E77-A4D1-3003D3F2BC06',
      phenomenonTime: '2017-12-15T11:20:00.000+0000',
      resultTime: '2017-12-15T11:25:07.219+0000',
      value: 76.1864406779661,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'FCCC833F-60FD-4751-9ADE-B8AE6AAACEC8',
      phenomenonTime: '2017-12-15T11:10:00.000+0000',
      resultTime: '2017-12-15T11:15:13.881+0000',
      value: 64.1833333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1150B854-8BFD-4364-8772-8EAA8ED63D50',
      phenomenonTime: '2017-12-15T11:00:00.000+0000',
      resultTime: '2017-12-15T11:05:11.160+0000',
      value: 53.05,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '69F68824-BCFC-4036-BCD5-5CC684876638',
      phenomenonTime: '2017-12-15T10:50:00.000+0000',
      resultTime: '2017-12-15T10:55:08.253+0000',
      value: 45.0,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E2DCA324-387C-4359-A58D-E4B351E7E7F9',
      phenomenonTime: '2017-12-15T10:40:00.000+0000',
      resultTime: '2017-12-15T10:45:15.162+0000',
      value: 35.95,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '6FE67103-13B9-44D8-B52B-3284C36ABC65',
      phenomenonTime: '2017-12-15T10:30:00.000+0000',
      resultTime: '2017-12-15T10:35:11.712+0000',
      value: 28.25,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1FC6A138-4358-406B-83FC-D988C0506C1F',
      phenomenonTime: '2017-12-15T10:20:00.000+0000',
      resultTime: '2017-12-15T10:25:09.374+0000',
      value: 22.2833333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '65107FA3-D1C4-4C70-90D2-E527B2F260E1',
      phenomenonTime: '2017-12-15T10:10:00.000+0000',
      resultTime: '2017-12-15T10:15:06.402+0000',
      value: 17.3898305084746,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '9CB46916-9109-4B2C-9337-50F78C3F7EF9',
      phenomenonTime: '2017-12-15T10:00:00.000+0000',
      resultTime: '2017-12-15T10:05:13.430+0000',
      value: 13.3166666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '3859EBC0-6E2A-430B-AA2D-9A526145B535',
      phenomenonTime: '2017-12-15T09:50:00.000+0000',
      resultTime: '2017-12-15T09:55:10.804+0000',
      value: 8.26666666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4CC1BC8F-EE7C-4FDF-94D7-36EB2A9923D6',
      phenomenonTime: '2017-12-15T09:40:00.000+0000',
      resultTime: '2017-12-15T09:45:07.926+0000',
      value: 4.76271186440678,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'A68A69B3-201E-4529-90C7-39CD057B3F1F',
      phenomenonTime: '2017-12-15T09:30:00.000+0000',
      resultTime: '2017-12-15T09:35:14.827+0000',
      value: 3.25,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '2A3508F9-1B8B-43E1-8E99-CD6570E1A947',
      phenomenonTime: '2017-12-15T09:20:00.000+0000',
      resultTime: '2017-12-15T09:25:11.579+0000',
      value: 1.91666666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '8FB9B56D-4165-4A3C-9DE7-05FB09E6AE51',
      phenomenonTime: '2017-12-15T09:10:00.000+0000',
      resultTime: '2017-12-15T09:15:09.045+0000',
      value: -1.10169491525424,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'FC73B6FC-D9DB-43A2-AF0F-4F538CF53CB9',
      phenomenonTime: '2017-12-15T09:00:00.000+0000',
      resultTime: '2017-12-15T09:05:16.203+0000',
      value: -2.36666666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '80589B65-F42F-49F2-93E2-8F51466719C8',
      phenomenonTime: '2017-12-15T08:50:00.000+0000',
      resultTime: '2017-12-15T08:55:13.342+0000',
      value: -2.05,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '479F898E-75D4-4947-A2F7-84B6C56C4F9E',
      phenomenonTime: '2017-12-15T08:40:00.000+0000',
      resultTime: '2017-12-15T08:45:10.081+0000',
      value: -3.35,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '79D2789E-1A42-4D03-ACF6-961D5085AD9C',
      phenomenonTime: '2017-12-15T08:30:00.000+0000',
      resultTime: '2017-12-15T08:35:07.221+0000',
      value: -2.91525423728814,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '61433F84-F823-4C4F-92FB-0C7B4D5F62EA',
      phenomenonTime: '2017-12-15T08:20:00.000+0000',
      resultTime: '2017-12-15T08:25:14.315+0000',
      value: -1.4,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '775F42F1-106E-4BD1-97A4-66C644FBB1BF',
      phenomenonTime: '2017-12-15T08:10:00.000+0000',
      resultTime: '2017-12-15T08:15:11.521+0000',
      value: -1.05,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E5E7EB1E-5154-4C14-B25D-430A240D0220',
      phenomenonTime: '2017-12-15T08:00:00.000+0000',
      resultTime: '2017-12-15T08:05:08.560+0000',
      value: 0.610169491525424,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '6FFF436C-44CB-48C9-9187-3493E6660B34',
      phenomenonTime: '2017-12-15T07:50:00.000+0000',
      resultTime: '2017-12-15T07:55:15.410+0000',
      value: 1.26666666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '44FD2D42-9711-44F5-981F-0608B2A75589',
      phenomenonTime: '2017-12-15T07:40:00.000+0000',
      resultTime: '2017-12-15T07:45:12.965+0000',
      value: 2.76666666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '27CE66C7-18D5-449B-80F7-AE5E8B76035B',
      phenomenonTime: '2017-12-15T07:30:00.000+0000',
      resultTime: '2017-12-15T07:35:10.069+0000',
      value: 4.38333333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'C323F2E2-7DC0-489B-9DAD-3D34C8D438E3',
      phenomenonTime: '2017-12-15T07:20:00.000+0000',
      resultTime: '2017-12-15T07:25:06.724+0000',
      value: 3.69491525423729,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'A2A20428-B9B6-4CEC-AB68-21F5FE62D78F',
      phenomenonTime: '2017-12-15T07:10:00.000+0000',
      resultTime: '2017-12-15T07:15:14.069+0000',
      value: 5.56666666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4B51748E-3B9F-4C95-B6D4-8693B7DDA487',
      phenomenonTime: '2017-12-15T07:00:00.000+0000',
      resultTime: '2017-12-15T07:05:30.432+0000',
      value: 5.21276595744681,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D0E0BA59-3B23-4159-B2F6-4DDF18FDC4FF',
      phenomenonTime: '2017-12-15T06:50:00.000+0000',
      resultTime: '2017-12-15T06:55:08.212+0000',
      value: 5.27118644067797,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '51DC4D4F-5716-4368-B04B-1F7ABC826945',
      phenomenonTime: '2017-12-15T06:40:00.000+0000',
      resultTime: '2017-12-15T06:45:14.997+0000',
      value: 6.58333333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E81D08B5-B3CC-4962-82B8-1F89AAE6E06E',
      phenomenonTime: '2017-12-15T06:30:00.000+0000',
      resultTime: '2017-12-15T06:35:12.339+0000',
      value: 6.76666666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'B5DAFE8B-6017-4CAA-BE96-C9771184C396',
      phenomenonTime: '2017-12-15T06:20:00.000+0000',
      resultTime: '2017-12-15T06:25:09.370+0000',
      value: 5.6,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D7C5287B-80C5-430F-8472-2F0EE8A29A99',
      phenomenonTime: '2017-12-15T06:10:00.000+0000',
      resultTime: '2017-12-15T06:15:06.596+0000',
      value: 6.42372881355932,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '5E5648D0-3230-4626-95DC-E6549A95385D',
      phenomenonTime: '2017-12-15T06:00:00.000+0000',
      resultTime: '2017-12-15T06:05:13.546+0000',
      value: 8.76666666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '7D31B3D3-EC0B-4B95-8DB7-1D62BDD8D8C0',
      phenomenonTime: '2017-12-15T05:50:00.000+0000',
      resultTime: '2017-12-15T05:55:10.413+0000',
      value: 10.05,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '58BC13B9-A76C-42D8-B8D8-E0FF8EE6E78F',
      phenomenonTime: '2017-12-15T05:40:00.000+0000',
      resultTime: '2017-12-15T05:45:07.679+0000',
      value: 9.5593220338983,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '33E6C438-5BE1-4AD9-B455-7CAD8D5ECE30',
      phenomenonTime: '2017-12-15T05:30:00.000+0000',
      resultTime: '2017-12-15T05:35:16.143+0000',
      value: 13.55,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '05DABF87-ED04-4496-B3D9-95F746C717A1',
      phenomenonTime: '2017-12-15T05:20:00.000+0000',
      resultTime: '2017-12-15T05:25:11.906+0000',
      value: 16.8166666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D881195A-6C16-46C6-B03B-F3609D1CCB0A',
      phenomenonTime: '2017-12-15T05:10:00.000+0000',
      resultTime: '2017-12-15T05:15:08.753+0000',
      value: 20.5593220338983,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'CFCAED57-3056-485D-8138-FD61F72278C9',
      phenomenonTime: '2017-12-15T05:00:00.000+0000',
      resultTime: '2017-12-15T05:05:16.237+0000',
      value: 23.1166666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '722E8A6C-6833-4422-9BD8-2D2EE006368C',
      phenomenonTime: '2017-12-15T04:50:00.000+0000',
      resultTime: '2017-12-15T04:55:13.201+0000',
      value: 29.0166666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '8B0B4FF1-E1E3-4130-9B7B-F659B3CC43F5',
      phenomenonTime: '2017-12-15T04:40:00.000+0000',
      resultTime: '2017-12-15T04:45:11.032+0000',
      value: 34.55,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '7FA668CB-BEF3-4996-B398-794918050E51',
      phenomenonTime: '2017-12-15T04:30:00.000+0000',
      resultTime: '2017-12-15T04:35:07.428+0000',
      value: 40.4915254237288,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D5D5E00A-619D-4A8F-BDCC-638425A00E69',
      phenomenonTime: '2017-12-15T04:20:00.000+0000',
      resultTime: '2017-12-15T04:25:14.385+0000',
      value: 46.9166666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1434D7F2-84D4-4317-9771-08D836741DA6',
      phenomenonTime: '2017-12-15T04:10:00.000+0000',
      resultTime: '2017-12-15T04:15:11.725+0000',
      value: 53.9333333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D1ADB7D1-7573-4AA1-AE44-435252645460',
      phenomenonTime: '2017-12-15T04:00:00.000+0000',
      resultTime: '2017-12-15T04:05:08.705+0000',
      value: 59.5423728813559,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '2D6516DB-A2C4-43E7-9D7B-629EAE2D1351',
      phenomenonTime: '2017-12-15T03:50:00.000+0000',
      resultTime: '2017-12-15T03:55:15.563+0000',
      value: 66.3833333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '29761A65-344B-4C36-9C57-99201033D5CC',
      phenomenonTime: '2017-12-15T03:40:00.000+0000',
      resultTime: '2017-12-15T03:45:12.673+0000',
      value: 74.3,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '8A2BE0CF-AE21-4877-BDBE-FC99049037DA',
      phenomenonTime: '2017-12-15T03:30:00.000+0000',
      resultTime: '2017-12-15T03:35:09.566+0000',
      value: 80.1333333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D9494151-1095-40FA-AD46-4018ACA3864D',
      phenomenonTime: '2017-12-15T03:20:00.000+0000',
      resultTime: '2017-12-15T03:25:06.941+0000',
      value: 87.0677966101695,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '16AAB448-848C-4C3E-9EF9-F69804B17CDF',
      phenomenonTime: '2017-12-15T03:10:00.000+0000',
      resultTime: '2017-12-15T03:15:13.718+0000',
      value: 92.4833333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '17CBBFB5-2A53-4AEC-AC85-6BE0A99C0868',
      phenomenonTime: '2017-12-15T03:00:00.000+0000',
      resultTime: '2017-12-15T03:05:10.990+0000',
      value: 97.9166666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '7E114B11-98C5-4222-B58B-638E02D3D65E',
      phenomenonTime: '2017-12-15T02:50:00.000+0000',
      resultTime: '2017-12-15T02:55:08.128+0000',
      value: 104.745762711864,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'EFB9E02D-3885-44CB-96F6-5C8B6620CCB2',
      phenomenonTime: '2017-12-15T02:40:00.000+0000',
      resultTime: '2017-12-15T02:45:15.264+0000',
      value: 109.4,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '041A1E62-B808-433B-8830-CBBC5E83AD75',
      phenomenonTime: '2017-12-15T02:30:00.000+0000',
      resultTime: '2017-12-15T02:35:13.885+0000',
      value: 114.266666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E6A2B709-9512-4E23-AB63-39192D35F0A3',
      phenomenonTime: '2017-12-15T02:20:00.000+0000',
      resultTime: '2017-12-15T02:25:09.331+0000',
      value: 118.216666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '63CF878C-E270-4D90-A099-C8BB46EDD9ED',
      phenomenonTime: '2017-12-15T02:10:00.000+0000',
      resultTime: '2017-12-15T02:15:07.054+0000',
      value: 123.35593220339,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '75ED437D-0FA2-4E67-B884-9554DD774715',
      phenomenonTime: '2017-12-15T02:00:00.000+0000',
      resultTime: '2017-12-15T02:05:13.507+0000',
      value: 128.25,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'A1D12BEA-1CD9-408F-AB65-6EFB32F42316',
      phenomenonTime: '2017-12-15T01:50:00.000+0000',
      resultTime: '2017-12-15T01:55:10.784+0000',
      value: 132.816666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '34957476-9A0C-4773-BEEC-25ACB2209E92',
      phenomenonTime: '2017-12-15T01:40:00.000+0000',
      resultTime: '2017-12-15T01:45:07.618+0000',
      value: 138.64406779661,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '6647E3D2-2981-4219-9FA8-5167E382FC03',
      phenomenonTime: '2017-12-15T01:30:00.000+0000',
      resultTime: '2017-12-15T01:35:14.801+0000',
      value: 142.683333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4400EBEB-3520-40B0-83ED-0D54A654F94D',
      phenomenonTime: '2017-12-15T01:20:00.000+0000',
      resultTime: '2017-12-15T01:25:11.786+0000',
      value: 145.883333333333,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '89580019-0DF0-444D-835C-ADDDD298A69F',
      phenomenonTime: '2017-12-15T01:10:00.000+0000',
      resultTime: '2017-12-15T01:15:09.147+0000',
      value: 150.101694915254,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '282DCDC3-9BA2-42D3-B601-7516C4B18D96',
      phenomenonTime: '2017-12-15T01:00:00.000+0000',
      resultTime: '2017-12-15T01:05:15.976+0000',
      value: 156.466666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '23B37034-493C-492A-84BD-5E8419F77200',
      phenomenonTime: '2017-12-15T00:50:00.000+0000',
      resultTime: '2017-12-15T00:55:13.116+0000',
      value: 160.716666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'B8C5BC78-1273-4A19-8BDF-BD17CC26225F',
      phenomenonTime: '2017-12-15T00:40:00.000+0000',
      resultTime: '2017-12-15T00:45:10.098+0000',
      value: 163.75,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '56CB7084-C277-4847-840C-A71E41F304F3',
      phenomenonTime: '2017-12-15T00:30:00.000+0000',
      resultTime: '2017-12-15T00:35:07.042+0000',
      value: 165.881355932203,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '6C3993A5-4610-4BF9-B3E6-355967682B83',
      phenomenonTime: '2017-12-15T00:20:00.000+0000',
      resultTime: '2017-12-15T00:25:14.128+0000',
      value: 168.016666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'BF5507DD-87A2-4E5D-A6FA-353B5657B2B5',
      phenomenonTime: '2017-12-15T00:10:00.000+0000',
      resultTime: '2017-12-15T00:15:11.560+0000',
      value: 169.466666666667,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'C8666C9D-B851-4300-82AF-7A9080E847E6',
      phenomenonTime: '2017-12-15T00:00:00.000+0000',
      resultTime: '2017-12-15T00:05:08.671+0000',
      value: 167.694915254237,
      feature: 'EEMH',
      datastream: 'H10',
      datum: 'NAP',
      uom: 'cm',
    },
    {
      id: '535B3565-E78D-4086-9B55-206AB098DF70',
      phenomenonTime: '2017-12-15T15:46:00.000+0000',
      resultTime: '2017-12-15T15:46:35.029+0000',
      value: 57.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '3D70DA35-58E6-49DB-90A7-DEF0899119E8',
      phenomenonTime: '2017-12-15T15:45:00.000+0000',
      resultTime: '2017-12-15T15:45:35.019+0000',
      value: 58.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '8B7772D1-1333-4F25-B56F-B7E3301F30F0',
      phenomenonTime: '2017-12-15T15:44:00.000+0000',
      resultTime: '2017-12-15T15:44:35.009+0000',
      value: 58.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'B233B7E7-EF6B-4D95-BF82-19E6BC2CEE3D',
      phenomenonTime: '2017-12-15T15:43:00.000+0000',
      resultTime: '2017-12-15T15:43:36.000+0000',
      value: 62.1666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '233CA6FB-0D86-4BE5-8A0E-6D01C0388184',
      phenomenonTime: '2017-12-15T15:42:00.000+0000',
      resultTime: '2017-12-15T15:42:35.990+0000',
      value: 62.1666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '5368E0F9-09B2-4D70-B823-7331F5F5E732',
      phenomenonTime: '2017-12-15T15:41:00.000+0000',
      resultTime: '2017-12-15T15:41:35.980+0000',
      value: 60.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '94571493-2D48-4976-8484-C181FBCB14FA',
      phenomenonTime: '2017-12-15T15:40:00.000+0000',
      resultTime: '2017-12-15T15:40:35.970+0000',
      value: 61.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '893CF42E-FEF1-4D05-BC28-7E37682B3EFA',
      phenomenonTime: '2017-12-15T15:39:00.000+0000',
      resultTime: '2017-12-15T15:39:35.960+0000',
      value: 60.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '7B65EEBA-4BAF-4AEB-A754-3B36DF7A5D11',
      phenomenonTime: '2017-12-15T15:38:00.000+0000',
      resultTime: '2017-12-15T15:38:35.950+0000',
      value: 63.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E27ADE1C-9EB4-4712-972A-FA21F8536C02',
      phenomenonTime: '2017-12-15T15:37:00.000+0000',
      resultTime: '2017-12-15T15:37:35.939+0000',
      value: 62.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '59F260F4-7CD8-488E-9AD9-F50968DE88B0',
      phenomenonTime: '2017-12-15T15:36:00.000+0000',
      resultTime: '2017-12-15T15:36:35.929+0000',
      value: 62.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D0E5951E-D721-43B6-B9BD-0B3297C0404C',
      phenomenonTime: '2017-12-15T15:35:00.000+0000',
      resultTime: '2017-12-15T15:35:35.918+0000',
      value: 64.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '2794F3A6-BC77-4860-9E55-C160E3112590',
      phenomenonTime: '2017-12-15T15:34:00.000+0000',
      resultTime: '2017-12-15T15:34:35.908+0000',
      value: 65.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'ED862E7B-B350-4AB0-8066-AD898C33E8CE',
      phenomenonTime: '2017-12-15T15:33:00.000+0000',
      resultTime: '2017-12-15T15:33:35.899+0000',
      value: 68.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'A8B64445-3D45-4840-A93D-DBA5E92609CF',
      phenomenonTime: '2017-12-15T15:32:00.000+0000',
      resultTime: '2017-12-15T15:32:35.888+0000',
      value: 66.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '9D652C3C-2155-4541-92E9-1B94385FE0D3',
      phenomenonTime: '2017-12-15T15:31:00.000+0000',
      resultTime: '2017-12-15T15:31:35.878+0000',
      value: 66.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D514CAD2-C092-459F-AFC8-951457B427A1',
      phenomenonTime: '2017-12-15T15:30:00.000+0000',
      resultTime: '2017-12-15T15:30:35.868+0000',
      value: 69.1666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'BF46F514-5D2B-4C3B-9022-1F97F18EE67E',
      phenomenonTime: '2017-12-15T15:29:00.000+0000',
      resultTime: '2017-12-15T15:29:35.856+0000',
      value: 69.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'CB742DC8-D2DA-4310-8BE7-0DE39007AF55',
      phenomenonTime: '2017-12-15T15:28:00.000+0000',
      resultTime: '2017-12-15T15:28:35.846+0000',
      value: 68.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E2328EE1-5B58-4912-AC1F-955EC8832B2C',
      phenomenonTime: '2017-12-15T15:27:00.000+0000',
      resultTime: '2017-12-15T15:27:35.835+0000',
      value: 69.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '6F4582E8-BB5F-41F8-959A-E28A1F938271',
      phenomenonTime: '2017-12-15T15:26:00.000+0000',
      resultTime: '2017-12-15T15:26:35.825+0000',
      value: 72.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '129E6DAA-EE24-44B5-B05C-5FE2D372A365',
      phenomenonTime: '2017-12-15T15:25:00.000+0000',
      resultTime: '2017-12-15T15:25:35.815+0000',
      value: 71.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '679C9A2B-2CAB-420B-A59E-761BD8D72FF5',
      phenomenonTime: '2017-12-15T15:24:00.000+0000',
      resultTime: '2017-12-15T15:24:35.804+0000',
      value: 67.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '937D9503-B4E7-472A-B488-D06B5C4A7B92',
      phenomenonTime: '2017-12-15T15:23:00.000+0000',
      resultTime: '2017-12-15T15:23:35.794+0000',
      value: 67.8,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D3D083A3-DF58-4A2C-81DB-B8D82C2E5112',
      phenomenonTime: '2017-12-15T15:22:00.000+0000',
      resultTime: '2017-12-15T15:22:35.785+0000',
      value: 72.4,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'AFD582C6-2631-48FD-B26F-2795434D6839',
      phenomenonTime: '2017-12-15T15:21:00.000+0000',
      resultTime: '2017-12-15T15:21:35.775+0000',
      value: 73.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '73302BED-4E52-44BE-A78F-4C80A5EB3765',
      phenomenonTime: '2017-12-15T15:20:00.000+0000',
      resultTime: '2017-12-15T15:20:35.764+0000',
      value: 72.2,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'BBD7EA1E-F5F4-476C-B1A9-B4AD8C7D032B',
      phenomenonTime: '2017-12-15T15:19:00.000+0000',
      resultTime: '2017-12-15T15:19:35.754+0000',
      value: 72.6,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'A7335443-F51C-4670-8668-9890272DE302',
      phenomenonTime: '2017-12-15T15:18:00.000+0000',
      resultTime: '2017-12-15T15:18:35.744+0000',
      value: 76.6,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '44B51352-E18A-40A2-A918-968FA93C0AE6',
      phenomenonTime: '2017-12-15T15:17:00.000+0000',
      resultTime: '2017-12-15T15:17:35.734+0000',
      value: 76.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'B4DB0D2D-3984-46F5-BA61-2911196010C5',
      phenomenonTime: '2017-12-15T15:16:00.000+0000',
      resultTime: '2017-12-15T15:16:35.724+0000',
      value: 75.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '0479B39A-AB7B-4ACE-A091-531AC35EE9B4',
      phenomenonTime: '2017-12-15T15:15:00.000+0000',
      resultTime: '2017-12-15T15:15:35.714+0000',
      value: 77.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'BAEAE69E-EC43-4855-AD14-104F79003303',
      phenomenonTime: '2017-12-15T15:14:00.000+0000',
      resultTime: '2017-12-15T15:14:35.704+0000',
      value: 80.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'EA496A54-47DA-4338-B925-F96724A47F01',
      phenomenonTime: '2017-12-15T15:13:00.000+0000',
      resultTime: '2017-12-15T15:13:35.694+0000',
      value: 79.1666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '325CF0F4-2568-4A25-ADB9-DB3F537FF684',
      phenomenonTime: '2017-12-15T15:12:00.000+0000',
      resultTime: '2017-12-15T15:12:35.684+0000',
      value: 77.1666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '44E6AD8D-4902-4C11-810F-99E4A18708D2',
      phenomenonTime: '2017-12-15T15:11:00.000+0000',
      resultTime: '2017-12-15T15:11:35.674+0000',
      value: 76.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E40BF9B0-1343-4DF9-AB6F-D83FE0848C7D',
      phenomenonTime: '2017-12-15T15:10:00.000+0000',
      resultTime: '2017-12-15T15:10:35.664+0000',
      value: 77.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '77B88037-9F45-4240-8185-2D6AAE7A398C',
      phenomenonTime: '2017-12-15T15:09:00.000+0000',
      resultTime: '2017-12-15T15:09:35.654+0000',
      value: 79.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '365127E6-734D-4A51-A006-2775D18713B2',
      phenomenonTime: '2017-12-15T15:08:00.000+0000',
      resultTime: '2017-12-15T15:08:35.643+0000',
      value: 79.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'C5B22813-551A-4B9D-B292-F0A5D78CB9C8',
      phenomenonTime: '2017-12-15T15:07:00.000+0000',
      resultTime: '2017-12-15T15:07:35.634+0000',
      value: 81.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E10CA8AA-E197-44EF-9477-1E26F2ED0E03',
      phenomenonTime: '2017-12-15T15:06:00.000+0000',
      resultTime: '2017-12-15T15:06:35.623+0000',
      value: 82.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '7EB682D4-3133-43BD-9172-F79F1E9043D2',
      phenomenonTime: '2017-12-15T15:05:00.000+0000',
      resultTime: '2017-12-15T15:05:35.613+0000',
      value: 86.1666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'BC54780E-F861-465E-B65B-08E0C5EA4580',
      phenomenonTime: '2017-12-15T15:04:00.000+0000',
      resultTime: '2017-12-15T15:04:35.604+0000',
      value: 85.1666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4D2CEA9A-E1FE-44DB-B523-215C07332BD1',
      phenomenonTime: '2017-12-15T15:03:00.000+0000',
      resultTime: '2017-12-15T15:03:35.594+0000',
      value: 82.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '13552481-64A1-4831-90EE-8E2114416BF9',
      phenomenonTime: '2017-12-15T15:02:00.000+0000',
      resultTime: '2017-12-15T15:02:35.165+0000',
      value: 80.75,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '0650422F-B88B-43A8-9879-15B7E4695771',
      phenomenonTime: '2017-12-15T15:02:00.000+0000',
      resultTime: '2017-12-15T15:02:35.584+0000',
      value: 81.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '73AFC8C1-1CD4-4C08-A122-0F1EC01785C0',
      phenomenonTime: '2017-12-15T15:01:00.000+0000',
      resultTime: '2017-12-15T15:01:35.575+0000',
      value: 84.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '5E92388F-6548-470F-BD17-C69B68C3D15D',
      phenomenonTime: '2017-12-15T15:00:00.000+0000',
      resultTime: '2017-12-15T15:00:35.566+0000',
      value: 86.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '35279733-8411-4FC9-BDD4-5C7A143EE6DC',
      phenomenonTime: '2017-12-15T15:00:00.000+0000',
      resultTime: '2017-12-15T15:00:35.900+0000',
      value: 86.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '884354FF-C9D8-48A0-8BA3-C9B8D7F20607',
      phenomenonTime: '2017-12-15T14:59:00.000+0000',
      resultTime: '2017-12-15T14:59:35.557+0000',
      value: 82.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D4688BF0-9541-4CA9-9584-058FE341E151',
      phenomenonTime: '2017-12-15T14:59:00.000+0000',
      resultTime: '2017-12-15T14:59:35.892+0000',
      value: 82.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E1DD3548-7753-4C08-935A-7DB7285E8F43',
      phenomenonTime: '2017-12-15T14:58:00.000+0000',
      resultTime: '2017-12-15T14:58:35.547+0000',
      value: 85.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '8A3967C1-DDA2-475C-88DA-4C5054BE3AF2',
      phenomenonTime: '2017-12-15T14:58:00.000+0000',
      resultTime: '2017-12-15T14:58:35.884+0000',
      value: 85.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4D944573-813B-4E6E-BBE8-656CC5686737',
      phenomenonTime: '2017-12-15T14:57:00.000+0000',
      resultTime: '2017-12-15T14:57:35.537+0000',
      value: 86.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'BABCE793-50A9-4562-A351-AB385A4579AA',
      phenomenonTime: '2017-12-15T14:57:00.000+0000',
      resultTime: '2017-12-15T14:57:35.877+0000',
      value: 86.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4A92AD6C-5B17-45BB-9D9C-939A13E1EF18',
      phenomenonTime: '2017-12-15T14:56:00.000+0000',
      resultTime: '2017-12-15T14:56:35.528+0000',
      value: 88.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '5C1095FB-E2EE-4C92-9E43-51DC02BA54B4',
      phenomenonTime: '2017-12-15T14:56:00.000+0000',
      resultTime: '2017-12-15T14:56:35.870+0000',
      value: 88.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4C8F0FBF-BDF9-429B-8F92-23E9A3BDA33B',
      phenomenonTime: '2017-12-15T14:55:00.000+0000',
      resultTime: '2017-12-15T14:55:35.518+0000',
      value: 85.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '101C14E5-1B6D-4122-81BF-CB66B5E461DB',
      phenomenonTime: '2017-12-15T14:55:00.000+0000',
      resultTime: '2017-12-15T14:55:35.863+0000',
      value: 85.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E5FA9FE9-9C4A-4859-AF5B-6F9847EFEB54',
      phenomenonTime: '2017-12-15T14:54:00.000+0000',
      resultTime: '2017-12-15T14:54:35.508+0000',
      value: 86.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'CAD45C0E-C2D4-48D0-9266-B574A5239640',
      phenomenonTime: '2017-12-15T14:54:00.000+0000',
      resultTime: '2017-12-15T14:54:35.856+0000',
      value: 86.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'E6B8D046-71E4-4E6D-8F8F-B87C134C4EE6',
      phenomenonTime: '2017-12-15T14:53:00.000+0000',
      resultTime: '2017-12-15T14:53:35.498+0000',
      value: 91.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '01E2A166-0B88-4826-8CEA-2C0976821003',
      phenomenonTime: '2017-12-15T14:53:00.000+0000',
      resultTime: '2017-12-15T14:53:35.848+0000',
      value: 91.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '34CE5F52-F9D5-4566-B36D-D028C5347B2D',
      phenomenonTime: '2017-12-15T14:52:00.000+0000',
      resultTime: '2017-12-15T14:52:35.488+0000',
      value: 91.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4F61162C-0283-40A1-AED3-FB0B5C554AB8',
      phenomenonTime: '2017-12-15T14:52:00.000+0000',
      resultTime: '2017-12-15T14:52:35.839+0000',
      value: 91.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'CDE013F8-A831-4C41-8277-035D848A3388',
      phenomenonTime: '2017-12-15T14:51:00.000+0000',
      resultTime: '2017-12-15T14:51:35.478+0000',
      value: 91.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'AEEB7F0A-E298-4CC5-AAE2-EC486A32D965',
      phenomenonTime: '2017-12-15T14:51:00.000+0000',
      resultTime: '2017-12-15T14:51:35.831+0000',
      value: 91.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '0F343C08-70B7-42A9-94EE-1ACA9AFC5F7A',
      phenomenonTime: '2017-12-15T14:50:00.000+0000',
      resultTime: '2017-12-15T14:50:35.467+0000',
      value: 90.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '46CAC349-21C2-436B-90E9-39444FB563D8',
      phenomenonTime: '2017-12-15T14:50:00.000+0000',
      resultTime: '2017-12-15T14:50:35.818+0000',
      value: 90.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '28D7470E-7FFF-4A64-BC0E-F5952C655B4A',
      phenomenonTime: '2017-12-15T14:49:00.000+0000',
      resultTime: '2017-12-15T14:49:35.457+0000',
      value: 91.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '26541073-167F-4AD3-8D74-CC4DA4373A80',
      phenomenonTime: '2017-12-15T14:49:00.000+0000',
      resultTime: '2017-12-15T14:49:35.810+0000',
      value: 91.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '89A6E8A3-81AF-46D3-9B34-4D706C0EE2DA',
      phenomenonTime: '2017-12-15T14:48:00.000+0000',
      resultTime: '2017-12-15T14:48:35.447+0000',
      value: 92.4,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1BC49F89-8175-46DE-8BE4-B20A0487DF16',
      phenomenonTime: '2017-12-15T14:48:00.000+0000',
      resultTime: '2017-12-15T14:48:35.802+0000',
      value: 92.4,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '4E093150-9F0C-4349-BE9F-FE18DF8F3591',
      phenomenonTime: '2017-12-15T14:47:00.000+0000',
      resultTime: '2017-12-15T14:47:35.436+0000',
      value: 90.8,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'FDA3BB86-63FE-432B-AD15-4B13A490743E',
      phenomenonTime: '2017-12-15T14:47:00.000+0000',
      resultTime: '2017-12-15T14:47:35.795+0000',
      value: 92.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '31D03433-D3F3-4873-9AC5-23765CA1A2F7',
      phenomenonTime: '2017-12-15T14:46:00.000+0000',
      resultTime: '2017-12-15T14:46:35.426+0000',
      value: 91.6,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '93415393-DDA6-445A-8450-86DBD4A99A12',
      phenomenonTime: '2017-12-15T14:45:00.000+0000',
      resultTime: '2017-12-15T14:45:35.416+0000',
      value: 93.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'B6308396-678E-4023-97C6-012E03686D05',
      phenomenonTime: '2017-12-15T14:44:00.000+0000',
      resultTime: '2017-12-15T14:44:35.405+0000',
      value: 95.4,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '6794A2AA-B7A0-4ABA-BE08-03B81E6AD71B',
      phenomenonTime: '2017-12-15T14:43:00.000+0000',
      resultTime: '2017-12-15T14:43:35.395+0000',
      value: 93.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'D86E4C2B-4245-43FC-9173-6B6CF79FD7C8',
      phenomenonTime: '2017-12-15T14:42:00.000+0000',
      resultTime: '2017-12-15T14:42:35.385+0000',
      value: 92.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '43F3AB68-A950-4FCC-8F26-95367FF9A706',
      phenomenonTime: '2017-12-15T14:41:00.000+0000',
      resultTime: '2017-12-15T14:41:35.374+0000',
      value: 94.1666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '23B6949A-DCC5-4016-B485-B9265F37B658',
      phenomenonTime: '2017-12-15T14:40:00.000+0000',
      resultTime: '2017-12-15T14:40:35.364+0000',
      value: 98.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '76BEEA28-3AB2-431C-964B-890539E2E47D',
      phenomenonTime: '2017-12-15T14:39:00.000+0000',
      resultTime: '2017-12-15T14:39:35.354+0000',
      value: 95.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'AE0A1818-2A34-4167-9AB4-096E53A9B808',
      phenomenonTime: '2017-12-15T14:38:00.000+0000',
      resultTime: '2017-12-15T14:38:35.344+0000',
      value: 96.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '53A94AB5-EF76-4217-B19C-133DA2FE1369',
      phenomenonTime: '2017-12-15T14:37:00.000+0000',
      resultTime: '2017-12-15T14:37:35.334+0000',
      value: 98.3333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'F182E5A7-1771-4133-8B77-B3B8AEC8FCB5',
      phenomenonTime: '2017-12-15T14:36:00.000+0000',
      resultTime: '2017-12-15T14:36:35.324+0000',
      value: 96.8333333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'FEE0D93E-DA73-4634-98DE-BC39FDBE8380',
      phenomenonTime: '2017-12-15T14:35:00.000+0000',
      resultTime: '2017-12-15T14:35:35.313+0000',
      value: 96.1666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '47064CD9-F7BA-4416-9B6A-31CB93A9463C',
      phenomenonTime: '2017-12-15T14:34:00.000+0000',
      resultTime: '2017-12-15T14:34:35.303+0000',
      value: 96.6666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '2FABBAE6-586C-47B3-AA7C-0EFB950BB0B6',
      phenomenonTime: '2017-12-15T14:33:00.000+0000',
      resultTime: '2017-12-15T14:33:35.293+0000',
      value: 98.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '408600A5-EA70-429A-8D9C-46B8ED19F551',
      phenomenonTime: '2017-12-15T14:32:00.000+0000',
      resultTime: '2017-12-15T14:32:35.283+0000',
      value: 102.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '74CF2A3B-04AB-4BDC-A026-5609F9349C68',
      phenomenonTime: '2017-12-15T14:31:00.000+0000',
      resultTime: '2017-12-15T14:31:35.273+0000',
      value: 102.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '73812330-097D-4D29-9AF3-1BC2FE79B832',
      phenomenonTime: '2017-12-15T14:30:00.000+0000',
      resultTime: '2017-12-15T14:30:35.263+0000',
      value: 101.833333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '2E82D9F6-2EBF-4417-B626-8F908E44AFA7',
      phenomenonTime: '2017-12-15T14:29:00.000+0000',
      resultTime: '2017-12-15T14:29:35.252+0000',
      value: 99.5,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '042C4A44-EB49-41D2-83F3-3D3EB27848D5',
      phenomenonTime: '2017-12-15T14:28:00.000+0000',
      resultTime: '2017-12-15T14:28:35.243+0000',
      value: 100.666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '1369AF1C-801D-4F8B-BB13-B78B8ECC4F79',
      phenomenonTime: '2017-12-15T14:27:00.000+0000',
      resultTime: '2017-12-15T14:27:35.233+0000',
      value: 103.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '36E24251-2990-41D0-BA16-9914BCC5FC01',
      phenomenonTime: '2017-12-15T14:26:00.000+0000',
      resultTime: '2017-12-15T14:26:35.223+0000',
      value: 101.166666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: '55D841E4-3CA4-4820-BFC5-88D4C9404399',
      phenomenonTime: '2017-12-15T14:25:00.000+0000',
      resultTime: '2017-12-15T14:25:35.214+0000',
      value: 103.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'DDD6FAD0-5E59-493B-B9D0-808BCA7B6C35',
      phenomenonTime: '2017-12-15T14:24:00.000+0000',
      resultTime: '2017-12-15T14:24:35.204+0000',
      value: 105.666666666667,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'BE7084F4-3049-4C71-B01F-F9908484D51C',
      phenomenonTime: '2017-12-15T14:23:00.000+0000',
      resultTime: '2017-12-15T14:23:35.194+0000',
      value: 104.0,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    }, {
      id: 'A35BF806-7060-4061-A857-B22A38CB480E',
      phenomenonTime: '2017-12-15T14:22:00.000+0000',
      resultTime: '2017-12-15T14:22:35.184+0000',
      value: 103.833333333333,
      feature: 'EEMH',
      datastream: 'H01',
      datum: 'NAP',
      uom: 'cm',
    },
  ],

};

export let mockSensorLogs: any = {
  content: [
    {
      sensorId: '01FEA107-B537-4393-97B2-D010100A65E1',
      user: 'Samira',
      actionTaken: 'not published',
      reason: 'test',
      actionTime: '2018-04-05T07:23:15.418+0000',
    },
    {
      sensorId: '01FEA107-B537-4393-97B2-D010100A65E1',
      user: 'Samira',
      actionTaken: 'published',
      reason: 'test',
      actionTime: '2018-04-05T07:25:15.418+0000',
    },
  ],
};

export let mockSensors: any = {
  content: [
    {
      id: '01FEA107-B537-4393-97B2-D010100A65E1',
      deviceId: 'H-S-MNS-AMH-RADR',
      name: 'H-S-MNS-AMH-RADR',
      startDate: '2016-12-31T23:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2020-12-31T23:00:00.000',
      processes: [
        {
          id: 'CBB0700C-EAA2-4722-B36B-27484B8A4C69',
          name: 'wl eem1 process',
          description: 'water level process for eem1',
          processType: {
            id: 'DBC53D5B-1E27-45E9-90D5-2259759BF72F',
            name: 'WL Sensor',
            description: 'Water level sensor',
            content: [],
            links: [],
          },
          datastreams: [
            {
              id: 'AC9BDA7F-B0D2-428E-BAA8-CFBB4B4B3419',
              checks: [
                {
                  id: '40154E0E-1836-4798-8B67-D675317DDA34',
                  checkTypeName: 'Delta',
                  active: true,
                  unitOfMeasurement: {
                    id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
                    name: 'cm',
                    description: 'Distance\/length',
                    quantity: 'Distance',
                    uomConversions: [
                      {
                        id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
                        fromUomName: 'cm',
                        toUomName: 'm',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  datum: {
                    id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
                    name: 'NAP',
                    description: 'Normaal Amsterdams Peil - average sea level',
                    type: 'Height',
                    value: 'NAP',
                    epsg: 0,
                    datumConversions: [
                      {
                        id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
                        fromDatumName: 'NAP',
                        toDatumName: 'ALAT',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  name: 'Delta',
                  params: [
                    {
                      name: 'value',
                      value: '15.0',
                    },
                  ],
                  content: [],
                  links: [],
                },
                {
                  id: 'E88856C2-D9F8-42CD-97F3-1332806C0C35',
                  checkTypeName: 'Extreme',
                  active: true,
                  unitOfMeasurement: {
                    id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
                    name: 'cm',
                    description: 'Distance\/length',
                    quantity: 'Distance',
                    uomConversions: [
                      {
                        id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
                        fromUomName: 'cm',
                        toUomName: 'm',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  datum: {
                    id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
                    name: 'NAP',
                    description: 'Normaal Amsterdams Peil - average sea level',
                    type: 'Height',
                    value: 'NAP',
                    epsg: 0,
                    datumConversions: [
                      {
                        id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
                        fromDatumName: 'NAP',
                        toDatumName: 'ALAT',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  name: 'Extreme',
                  params: [
                    {
                      name: 'max',
                      value: '400.0',
                    },
                    {
                      name: 'min',
                      value: '-200.0',
                    },
                  ],
                  content: [],
                  links: [],
                },
              ],
              property: {
                id: '587AA289-4E52-4807-BEDF-BC662EB82732',
                name: 'H',
                description: 'Gemeten waterstand',
                propertyType: {
                  id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
                  name: 'GT',
                  description: 'Waterstand',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
                  name: 'cm',
                  description: 'Distance\/length',
                  quantity: 'Distance',
                  uomConversions: [
                    {
                      id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
                      fromUomName: 'cm',
                      toUomName: 'm',
                      content: [],
                      links: [],
                    },
                  ],
                  content: [],
                  links: [],
                },
                datum: {
                  id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
                  name: 'NAP',
                  description: 'Normaal Amsterdams Peil - average sea level',
                  type: 'Height',
                  value: 'NAP',
                  epsg: 0,
                  datumConversions: [
                    {
                      id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
                      fromDatumName: 'NAP',
                      toDatumName: 'ALAT',
                      content: [],
                      links: [],
                    },
                  ],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              datastreamType: {
                id: 'E9E8254A-26D0-11E8-B467-0ED5F89F718B',
                content: [],
                links: [],
              },
            },
            {
              id: '0282B3D0-6697-4107-975F-67E3CBB4C4E2',
              checks: [
                {
                  id: '77C087F8-FE43-4772-99F3-06D5FF99408F',
                  checkTypeName: 'Distribution',
                  active: true,
                  unitOfMeasurement: {
                    id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
                    name: 'cm',
                    description: 'Distance\/length',
                    quantity: 'Distance',
                    uomConversions: [
                      {
                        id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
                        fromUomName: 'cm',
                        toUomName: 'm',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  datum: {
                    id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
                    name: 'NAP',
                    description: 'Normaal Amsterdams Peil - average sea level',
                    type: 'Height',
                    value: 'NAP',
                    epsg: 0,
                    datumConversions: [
                      {
                        id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
                        fromDatumName: 'NAP',
                        toDatumName: 'ALAT',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  name: 'Distribution',
                  params: [
                    {
                      name: 'value',
                      value: '21.0',
                    },
                  ],
                  content: [],
                  links: [],
                },
                {
                  id: '75D40C8D-99DD-44F7-BF34-D0D04F63583F',
                  checkTypeName: 'Count',
                  active: true,
                  unitOfMeasurement: {
                    id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
                    name: 'cm',
                    description: 'Distance\/length',
                    quantity: 'Distance',
                    uomConversions: [
                      {
                        id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
                        fromUomName: 'cm',
                        toUomName: 'm',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  datum: {
                    id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
                    name: 'NAP',
                    description: 'Normaal Amsterdams Peil - average sea level',
                    type: 'Height',
                    value: 'NAP',
                    epsg: 0,
                    datumConversions: [
                      {
                        id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
                        fromDatumName: 'NAP',
                        toDatumName: 'ALAT',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  name: 'Count',
                  params: [
                    {
                      name: 'value',
                      value: '5.0',
                    },
                  ],
                  content: [],
                  links: [],
                },
              ],
              property: {
                id: '20EA3CB5-4231-4B35-AD6B-8B8E4DFC0761',
                name: 'H01',
                description: '1 minuut waterstand',
                propertyType: {
                  id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
                  name: 'GT',
                  description: 'Waterstand',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
                  name: 'cm',
                  description: 'Distance\/length',
                  quantity: 'Distance',
                  uomConversions: [
                    {
                      id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
                      fromUomName: 'cm',
                      toUomName: 'm',
                      content: [],
                      links: [],
                    },
                  ],
                  content: [],
                  links: [],
                },
                datum: {
                  id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
                  name: 'NAP',
                  description: 'Normaal Amsterdams Peil - average sea level',
                  type: 'Height',
                  value: 'NAP',
                  epsg: 0,
                  datumConversions: [
                    {
                      id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
                      fromDatumName: 'NAP',
                      toDatumName: 'ALAT',
                      content: [],
                      links: [],
                    },
                  ],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              datastreamType: {
                id: 'E9E8254A-26D0-11E8-B467-0ED5F89F718B',
                content: [],
                links: [],
              },
            },
            {
              id: 'DEFDADF2-90D9-4E72-8401-FC5489B27735',
              checks: [
                {
                  id: '1D15337B-ADBD-4C42-85F1-FDCAE9BA35FF',
                  checkTypeName: 'Count',
                  active: true,
                  unitOfMeasurement: {
                    id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
                    name: 'cm',
                    description: 'Distance\/length',
                    quantity: 'Distance',
                    uomConversions: [
                      {
                        id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
                        fromUomName: 'cm',
                        toUomName: 'm',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  datum: {
                    id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
                    name: 'NAP',
                    description: 'Normaal Amsterdams Peil - average sea level',
                    type: 'Height',
                    value: 'NAP',
                    epsg: 0,
                    datumConversions: [
                      {
                        id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
                        fromDatumName: 'NAP',
                        toDatumName: 'ALAT',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  name: 'Count',
                  params: [
                    {
                      name: 'value',
                      value: '54.0',
                    },
                  ],
                  content: [],
                  links: [],
                },
                {
                  id: '1C2BD8F2-7276-42CB-9E18-779B4F503319',
                  checkTypeName: 'Distribution',
                  active: true,
                  unitOfMeasurement: {
                    id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
                    name: 'cm',
                    description: 'Distance\/length',
                    quantity: 'Distance',
                    uomConversions: [
                      {
                        id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
                        fromUomName: 'cm',
                        toUomName: 'm',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  datum: {
                    id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
                    name: 'NAP',
                    description: 'Normaal Amsterdams Peil - average sea level',
                    type: 'Height',
                    value: 'NAP',
                    epsg: 0,
                    datumConversions: [
                      {
                        id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
                        fromDatumName: 'NAP',
                        toDatumName: 'ALAT',
                        content: [],
                        links: [],
                      },
                    ],
                    content: [],
                    links: [],
                  },
                  name: 'Distribution',
                  params: [
                    {
                      name: 'value',
                      value: '61.0',
                    },
                  ],
                  content: [],
                  links: [],
                },
              ],
              property: {
                id: '26411F68-300E-4E21-BD94-46DBDA2D5E35',
                name: 'H10',
                description: '10 minuut waterstand',
                propertyType: {
                  id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
                  name: 'GT',
                  description: 'Waterstand',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
                  name: 'cm',
                  description: 'Distance\/length',
                  quantity: 'Distance',
                  uomConversions: [
                    {
                      id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
                      fromUomName: 'cm',
                      toUomName: 'm',
                      content: [],
                      links: [],
                    },
                  ],
                  content: [],
                  links: [],
                },
                datum: {
                  id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
                  name: 'NAP',
                  description: 'Normaal Amsterdams Peil - average sea level',
                  type: 'Height',
                  value: 'NAP',
                  epsg: 0,
                  datumConversions: [
                    {
                      id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
                      fromDatumName: 'NAP',
                      toDatumName: 'ALAT',
                      content: [],
                      links: [],
                    },
                  ],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              datastreamType: {
                id: 'E9E8254A-26D0-11E8-B467-0ED5F89F718B',
                content: [],
                links: [],
              },
            },
          ],
          sensorName: 'eem1',
          content: [],
          links: [
            {
              rel: 'feature',
              href: 'http://localhost:8080/api/v1/features/3B3734FA-5BB9-4D94-9A7D-8B611B9AC610',
            },
            {
              rel: 'sensor',
              href: 'http://localhost:8080/api/v1/sensors/01FEA107-B537-4393-97B2-D010100A65E1',
            },
          ],
        },
      ],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: true,
      status: 'PUBLISHING',
      publishing: false,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
      locationName: 'Rozenburgsesluis Hartelkanaal',
    },
    {
      id: '7C2A0925-A681-47ED-B3DB-1F1AFF59CBAD',
      deviceId: '0911A6D3-0F5D-4278-BAC4-658FFE903974',
      name: 'SAP-TR-101',
      startDate: '2017-12-15T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2030-12-15T22:00:00.000+0000',
      processes: [],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: true,
      status: 'NOT PUBLISHING',
      publishing: false,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
      locationName: 'Parkhaven',
    },
    {
      id: '2A7DD923-0749-491B-8E5A-EFAC41B8EB1F',
      deviceId: 'H-S-MNS-TS-RADR',
      name: 'H-S-MNS-GRUN-ADCP ',
      startDate: '2017-12-08T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2030-12-08T22:00:00.000+0000',
      active: true,
      status: 'SENSOR OFF',
      publishing: true,
      processes: [],
      wkid: 28992,
      x: 78252,
      y: 443855,
      z: 0,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Tidal Stream',
        description: 'Tidal Stream Sensor',
        deviceType: 'tidalstream',
        content: [],
        links: [],
      },
      locationName: 'Groningen',
    },
    {
      id: '24C38B0B-1467-45F1-A7E0-5C141705D054',
      deviceId: 'F4041872-925B-4AA1-9EF7-DC3AF61DC3D3',
      name: 'SAP-TR-102',
      startDate: '2017-12-08T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2030-12-08T22:00:00.000+0000',
      processes: [],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: true,
      status: 'NOT PUBLISHING',
      publishing: false,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
      locationName: 'Rozenburgsesluis Calandkanaal',
    },
    {
      id: '4371E95C-6F57-4E31-B483-6243938518D1',
      deviceId: '8BDEA6E8-E920-453D-806A-D2F3F2235A2F',
      name: 'SAP-TR-103',
      startDate: '2017-12-15T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2030-12-15T22:00:00.000+0000',
      processes: [],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: true,
      status: 'NOT PUBLISHING',
      publishing: true,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
      locationName: 'Amaliahaven',
    },
    {
      id: '4EAD5204-001D-4338-9525-6E36BF46171D',
      deviceId: '5D72F19B-330A-4CE3-894E-3540E7AA08D5',
      name: 'SAP-TR-199',
      startDate: '2017-12-08T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2030-12-08T22:00:00.000+0000',
      processes: [],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: true,
      status: 'NOT PUBLISHING',
      publishing: false,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
      locationName: '1e Eemhaven',
    },
    {
      id: '60064FEC-28B2-4BBC-B2E5-7E9D3D729904',
      deviceId: 'D8779FB4-E6C5-419B-B082-4F6EDA381163',
      name: 'SAP-TR-XYZ',
      startDate: '2017-12-08T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2030-12-08T22:00:00.000+0000',
      processes: [],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: true,
      status: 'NOT PUBLISHING',
      publishing: false,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
      locationName: 'Europahaven',
    },
    {
      id: 'B0811494-F5B4-43CB-80B9-2D422AE43201',
      deviceId: '706B143D-ED7A-4915-B572-E099C65DD1DC',
      name: 'SAP-TR-ABC',
      startDate: '2017-12-15T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2030-12-15T22:00:00.000+0000',
      processes: [],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: true,
      status: 'NOT PUBLISHING',
      publishing: false,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
      locationName: 'Hartelsluis',
    },
    {
      id: '1E1B5596-7FDB-4870-B0C2-5D681EAED08F',
      deviceId: 'CD612478-A9D2-4777-9A4E-62355233A556',
      name: 'SAP-TR-99',
      startDate: '2017-12-22T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2030-12-22T22:00:00.000+0000',
      processes: [],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: true,
      status: 'NOT PUBLISHING',
      publishing: false,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
      locationName: 'Hartelhaven',
    },
    {
      id: 'BB400BF0-4626-44D3-995B-77C4D61190E3',
      deviceId: '0584590E-6E7C-41BD-94CD-13C70D9A8A5D',
      name: 'SAP-TR-QWERTY',
      startDate: '2017-12-01T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2030-12-01T22:00:00.000+0000',
      processes: [],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: true,
      status: 'NOT PUBLISHING',
      publishing: false,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
      locationName: 'gRO',
    },
    {
      id: 'F31BC96F-B98E-4F76-8DCB-A46B703C5A79',
      deviceId: 'C653D824-CE1E-4E7E-9E7B-0B13B626A790',
      name: 'TEST',
      startDate: '2017-11-30T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2017-12-30T22:00:00.000+0000',
      processes: [],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: true,
      status: 'NOT PUBLISHING',
      publishing: false,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
      locationName: 'Geulhaven Radarpost 10',
    },
    {
      id: '865CA35D-D12D-4CCC-81B7-1B4028B7D3D1',
      deviceId: '8D614FA4-BC5C-4B07-ADEE-FD6BC003F4C5',
      name: 'SAP-TR-0987',
      locationName: 'Kuip2 Radarpost 23',
      startDate: '2017-12-08T22:00:00.000+0000',
      instrumentType: 'RADAR',
      endDate: '2030-12-08T22:00:00.000+0000',
      processes: [],
      wkid: 28992,
      x: 88252,
      y: 433855,
      z: 0,
      active: false,
      status: 'SENSOR OFF',
      publishing: false,
      gatewayId: 'FCW210900AM',
      gatewayType: 'Cisco_IR8x9_GW',
      sensorType: {
        id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
        name: 'Height of Tide',
        description: 'Water level sensor',
        deviceType: 'waterstand',
        content: [],
        links: [],
      },
    },
  ],
};

export let mockSensorsWithFeatureList: any = {
  content: [
    {
      id: mockSensors.content[0].id,
      features: [
        {
          featureType: {
            name: 'Height of tide',
            description: 'Water level, high water and low water',
          },
          id: 'FF457ED3-270F-4FDA-9096-DCCF1B8856E9',
          name: '1EEMH',
          description: '1e Eemhaven',
          active: true,
          endDate: new Date('2020-12-31T23:00:00.000'),
          x: 4.0,
          y: 100.0,
          z: 200.0,
          featureMetadata: [
            {
              value: '15',
              attribute: 'Conversion NAP to (A)LAT (cm)',
            },
          ],
          processes: mockSensors.content[0].processes,
        },
      ],
    },
    {
      id: mockSensors.content[1].id,
      features: [
        {
          featureType: {
            name: 'Height of tide',
            description: 'Water level, high water and low water',
          },
          id: '59C2C86F-3196-44FD-99E6-062526DE9BD4',
          name: 'PARKH',
          description: 'Parkhaven',
          active: true,
          endDate: new Date('2020-12-31T23:00:00.000'),
          x: 204.0,
          y: 2212.0,
          z: 2312.0,
          featureMetadata: [
            {
              value: '25',
              attribute: 'Conversion NAP to (A)LAT (cm)',
            },
          ],
          processes: mockSensors.content[1].processes,
        },
      ],
    },
    {
      id: mockSensors.content[2].id,
      features: [
        {
          featureType: {
            name: 'Tidal stream',
            description: 'Tidal stream rate and direction / current magnitude and direction and slack water',
          },
          id: '4C557A46-666E-46CC-BCD4-1D12D40ACBD0',
          name: 'GRUN',
          description: 'Groningen',
          active: true,
          endDate: new Date('2020-12-31T23:00:00.000'),
          x: 104.0,
          y: 212.0,
          z: 312.0,
          featureMetadata: [
            {
              value: '10',
              attribute: 'Distance',
            },
            {
              value: '59',
              attribute: 'Minimum flood direction degrees clockwise',
            },
            {
              value: '339',
              attribute: 'Maximum flood direction degrees clockwise',
            },
          ],
          processes: mockSensors.content[2].processes,
        },
      ],
    },
  ],
};

export const mockSensorSummaries: SensorSummary[] = [
  {
    id: mockSensors.content[0].id,
    name: mockSensors.content[0].name,
    locationName: 'fake-location',
    deviceId: mockSensors.content[0].name,
    sensorTypeDescription: mockSensors.content[0].sensorType.description,
    startDate: moment('2018-08-29T12:39:53.175+0000').toDate(),
    endDate: moment('2068-08-29T12:39:53.175+0000').toDate(),
    status: 'PUBLISHING',
  },
  {
    id: mockSensors.content[1].id,
    name: mockSensors.content[1].name,
    locationName: 'fake-location',
    deviceId: mockSensors.content[1].name,
    sensorTypeDescription: mockSensors.content[1].sensorType.description,
    startDate: moment('2018-08-29T12:39:53.175+0000').toDate(),
    endDate: moment('2068-08-29T12:39:53.175+0000').toDate(),
    status: 'NOT PUBLISHING',
  },
  {
    id: mockSensors.content[2].id,
    name: mockSensors.content[2].name,
    locationName: 'fake-location-three',
    deviceId: mockSensors.content[2].name,
    sensorTypeDescription: mockSensors.content[2].sensorType.description,
    startDate: moment('2018-08-30T12:39:53.175+0000').toDate(),
    endDate: moment('2068-08-30T12:39:53.175+0000').toDate(),
    status: 'SENSOR OFF',
  },
];

export let mockActivities: any = {
  activities: [
    {
      date: '11-12-2017',
      time: '10:00',
      sensorMode: 'Sensor off',
      reason: 'There is something happening',
      user: 'Samira',
    },
    {
      date: '11-12-2017',
      time: '11:00',
      sensorMode: 'Sensor off',
      reason: 'There is something happening',
      user: 'Samira',
    },
    {
      date: '11-12-2017',
      time: '12:00',
      sensorMode: 'Sensor off',
      reason: 'There is something happening',
      user: 'Samira',
    },
  ],
};

export let mockLocations: any = {

  locations: [
    {
      id: '1C10615C-D749-4AD3-9014-38ED7753A9F9',
      name: 'Eerste Eemhaven',
      description: 'Eemhaven location',
      code: 'EEM1',
      _links: {
        self: {
          href: 'https://hbr-hm-observations-service-dev.eu-gb.mybluemix.net/api/v1/locations/1C10615C-D749-4AD3-9014-38ED7753A9F9',
        },
        location: {
          href: 'https://hbr-hm-observations-service-dev.eu-gb.mybluemix.net/api/v1/locations/1C10615C-D749-4AD3-9014-38ED7753A9F9',
        },
      },
    }, {
      id: 'BF2BBC3F-C7BA-4C39-8310-489F41A9611A',
      name: 'Amaliahaven',
      code: 'AMHA',
      _links: {
        self: {
          href: 'https://hbr-hm-observations-service-dev.eu-gb.mybluemix.net/api/v1/locations/BF2BBC3F-C7BA-4C39-8310-489F41A9611A',
        },
        location: {
          href: 'https://hbr-hm-observations-service-dev.eu-gb.mybluemix.net/api/v1/locations/BF2BBC3F-C7BA-4C39-8310-489F41A9611A',
        },
      },
    }, {
      id: 'F8CE65D1-CC82-47F0-BDB1-75FAAE5F887D',
      name: 'Botlekbrug 37 m',
      code: 'B037',
      _links: {
        self: {
          href: 'https://hbr-hm-observations-service-dev.eu-gb.mybluemix.net/api/v1/locations/F8CE65D1-CC82-47F0-BDB1-75FAAE5F887D',
        },
        location: {
          href: 'https://hbr-hm-observations-service-dev.eu-gb.mybluemix.net/api/v1/locations/F8CE65D1-CC82-47F0-BDB1-75FAAE5F887D',
        },
      },
    }, {
      id: 'CE27002C-97FB-463D-A2C7-013BF3E3EA82',
      name: 'Boerengat',
      code: 'BOER',
      _links: {
        self: {
          href: 'https://hbr-hm-observations-service-dev.eu-gb.mybluemix.net/api/v1/locations/CE27002C-97FB-463D-A2C7-013BF3E3EA82',
        },
        location: {
          href: 'https://hbr-hm-observations-service-dev.eu-gb.mybluemix.net/api/v1/locations/CE27002C-97FB-463D-A2C7-013BF3E3EA82',
        },
      },
    }],
};

export const mockSensorTypes: any = {
  sensorTypes: [
    {
      id: 'C28DB455-E7F4-4457-8199-CE8F7C052C30',
      name: 'waterstand',
      description: 'Water level sensor',
      code: 'Sensor',
      deviceType: 'waterlevel',
    },
    {
      id: '77222C79-C24A-4500-8446-15A562A46BA1',
      name: 'wind',
      description: 'Wind sensor',
      code: 'Sensor',
      deviceType: 'windmierij',
    },
    {
      id: 'AA4B597B-BBC8-4E1B-B770-A92B14CC67E8',
      name: 'Cisco_IR8x9_GW',
      description: 'Gateway',
      code: 'Gateway',
      deviceType: 'visibility',
    },
    {
      id: 'A60FB332-3450-4EA3-A491-1FEA43936019',
      name: 'Tidal stream',
      description: 'Tidal stream',
      deviceType: 'tidalstream',
    },
  ],
};

export const mockAstronomicalPredicationsMetaData: any = {
  astronomicalPredictionsMetaData: [
    new MetaData({
      dateTime: '2018-01-17 15:40:46',
      fileType: 'Water Level',
      location: 'Eemhaven',
      name: 'VLAA2.txt',
      user: 'Samira',
      status: 'Failed',
      message: 'message-failed',
      getDate() {
        return new Date('2018-01-17 15:40:46');
      },
    }),
    new MetaData({
      dateTime: '2018-01-18 14:35:41',
      fileType: 'Water Level',
      name: 'VLAA1.txt',
      location: 'Vlaardingen',
      user: 'Samira',
      status: 'Success',
      message: 'message-success',
      getDate() {
        return new Date('2018-01-18 14:35:41');
      },
    }),
  ],
};

export const mockOsrMetaData: any = {
  osrMetaData: [
    {
      dateTime: '2018-05-01 22:13:00',
      source: 'MX-MOCK',
      name: 'osr_fv_iot.txt',
      quantity: 'Samira',
      status: 'Failed',
      getDate() {
        return new Date('2018-05-01 22:13:00');
      },
    },
    {
      dateTime: '2018-05-01 22:13:00',
      source: 'MX-MOCK',
      name: 'osr_gt_iot.txt',
      quantity: 'Samira',
      status: 'Failed',
      getDate() {
        return new Date('2018-05-01 22:13:00');
      },
    },
    {
      dateTime: '2018-05-01 23:13:00',
      source: 'MX-MOCK',
      name: 'osr_gt_iot.txt',
      quantity: 'Samira',
      status: 'Success',
      message: 'Message successfully imported',
      getDate() {
        return new Date('2018-05-01 23:13:00');
      },
    },
    {
      dateTime: '2018-05-02 07:13:00',
      source: 'MX-MOCK',
      name: 'osr_fv_iot.txt',
      quantity: 'Samira',
      status: 'Success',
      message: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin' +
        ' literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney ' +
        'College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, ' +
        'and going through the cites of the word in classical literature, discovered the undoubtable source.',
      getDate() {
        return new Date('2018-05-02 07:13:00');
      },
    },
    {
      dateTime: '2018-05-02 07:13:00',
      source: 'MX-MOCK',
      name: 'osr_sa_iot.txt',
      quantity: 'Samira',
      status: 'Success',
      message: 'Message successfully imported',
      getDate() {
        return new Date('2018-05-02 07:13:00');
      },
    },
  ],
};

export const mockNormalOsrMetaData: OsrMetaData = new OsrMetaData(
  {
    dateTime: '2018-05-02 07:13:00',
    source: 'MX-MOCK',
    name: 'osr_sa_iot.txt',
    quantity: 'Samira',
    status: 'Success',
    message: 'Message successfully imported',
    getDate() {
      return new Date('2018-05-01 07:13:00');
    },
  }
);

export const mockLateOsrMetaData: OsrMetaData = new OsrMetaData(
  {
    dateTime: '2018-05-01 07:13:00',
    source: 'MX-MOCK',
    name: 'osr_sa_iot.txt',
    quantity: 'Samira',
    status: 'Success',
    message: 'Message successfully imported',
    getDate() {
      return new Date('2018-05-01 07:13:00');
    },
  }
);

export const mockRwsMetaData: any = {
  rwsMetaData: [
    new RwsMetaData(
      {
        locationNamePoR: 'Hoek van Holland',
        locationCodeRWS: 'HOEK',
        items: [
          {
            propertyCodePoR: 'fake-property-code-por-1a',
            parameterCodeRWS: 'fake-parameter-code-rws-1a',
            status: 'fake-status-1a',
            lastUpdate: '05/02/2018 06:50:00',
            lastImport: '05/02/2018 10:00:00',
          },
          {
            propertyCodePoR: 'fake-property-code-por-1b',
            parameterCodeRWS: 'fake-parameter-code-rws-1b',
            status: 'fake-status-1b',
            lastUpdate: '05/02/2018 06:50:00',
            lastImport: '05/02/2018 10:00:01',
          },
        ],

        getDate() {
          return new Date('2018-05-02 16:50:00');
        },
      }),
    new RwsMetaData({
      locationNamePoR: 'Eemshaven',
      locationCodeRWS: 'EEMS',
      items: [
        {
          propertyCodePoR: 'fake-property-code-por-2a',
          parameterCodeRWS: 'fake-parameter-code-rws-2a',
          status: RwsMetaData.STATUS_SUCCEEDED,
          lastUpdate: '05/02/2018 07:00:00',
          lastImport: '05/02/2018 10:00:01',
        },
        {
          propertyCodePoR: 'fake-property-code-por-2b',
          parameterCodeRWS: 'fake-parameter-code-rws-2b',
          status: RwsMetaData.STATUS_SUCCEEDED,
          lastUpdate: '05/02/2018 07:00:00',
          lastImport: '05/02/2018 10:00:03',
        },
      ],
      getDate() {
        return new Date('2018-05-02 17:00:00');
      },
    }),
  ],
};

const iotDevices: Device[] = [
  new Device(
    'H-S-MNS-AMAL-RADR',
    '2018-04-19T10:56:00.000+0000',
    'Groningen',
    'gatewayId',
    'gatewayTypeId',
    'waterlevel',
    false,
    ''),
  new Device(
    'H-S-MNS-BMV2-ZCHT',
    '2018-07-02T11:27:00.000+0000',
    'Groningen',
    'gatewayId',
    'gatewayTypeId',
    'visibility',
    false,
    ''),
  new Device(
    'H-S-MNS-HARB-CTDS',
    '2018-07-02T11:27:00.000+0000',
    'Groningen2',
    'gatewayId',
    'gatewayTypeId',
    'salinity',
    false,
    ''),
  new Device(
    'H-S-MNS-HARR-RADR',
    '2018-05-01T12:05:00.000+0000',
    'Groningen3',
    'gatewayId',
    'gatewayTypeId',
    'iotDeviceType',
    false,
    ''),
  new Device(
    'H-S-MNS-TS-RADR',
    '2018-05-01T12:05:00.000+0000',
    'Groningen4',
    'gatewayId',
    'gatewayTypeId',
    'tidalstream',
    false,
    ''),
  new Device(
    'H-S-MNS-AMH-RADR',
    '2018-05-01T12:05:00.000+0000',
    'Groningen5',
    'gatewayId',
    'gatewayTypeId',
    'waterstand',
    false,
    ''),
];

export const mockIotDevices: any = {iotDevices: iotDevices};

// header names and mockTableObject property information, used in the TableComponent.
export const mockTableProperties: TableProperties[] = [
  {
    header: 'Name',
    accessor: {main: 'name'},
    containsDate: false,
  },
  {
    header: 'Location name',
    accessor: {
      main: 'location',
      sub: 'name',
    },
    containsDate: false,
  },
  {
    header: 'Sensor stream',
    accessor: {
      main: 'device',
      sub: 'deviceTypeDescription',
    },
    containsDate: false,
  },
  {
    header: 'Start date',
    accessor: {main: 'startDate'},
    containsDate: true,
  },
  {
    header: 'End date',
    accessor: {main: 'endDate'},
    containsDate: true,
  },
  {
    header: 'Nested date',
    accessor: {
      main: 'otherDates',
      sub: 'nestedDateOne',
    },
    containsDate: true,
  },
  {
    header: 'Actions',
    accessor: {main: false},
    containsDate: false,
  },
];

export const mockOsrTableProperties: TableProperties[] = [
  {header: 'Date', accessor: {main: 'dateTime'}, containsDate: true},
  {header: 'Local Time', accessor: {main: 'time'}, containsDate: false},
  {header: 'Source', accessor: {main: 'source'}, containsDate: false},
  {header: 'File Name', accessor: {main: 'name'}, containsDate: false},
  {header: 'Quantity', accessor: {main: 'quantity'}, containsDate: false},
  {header: 'Status', accessor: {main: 'status'}, containsDate: false},
  {header: 'Message', accessor: {main: 'message'}, containsDate: false},
];

// objects whose properties (specified in mockTableProperties) are shown in a table row of the TableComponent.
export const mockTableObjects: object[] = [
  {
    name: 'testName',
    location: {
      name: 'testName',
    },
    device: {
      deviceTypeDescription: 'testDescription',
    },
    startDate: '2010-01-01',
    endDate: '2020-02-02',
    otherDates: {
      nestedDateOne: '2030-03-03',
      nestedDateTwo: '2040-04-04',
    },
  },
];

export const observationsBySensorMock = [
  [
    {
      id: '35784C45-54C5-44FB-8CAE-368BAA3027F4',
      phenomenonTime: moment('2018-02-07T14:17:59.124+0000').toDate(),
      resultTime: moment('2018-02-07T14:18:05.597+0000').toDate(),
      value: -55,
      feature: 'EEM1',
      datastream: 'H',
      uom: 'cm',
      datum: 'NAP',
      validityStart: null,
      validityEnd: null,
      results: {
        Delta: 'passed',
        Extreme: 'passed',
      },
    },
  ],
  [
    {
      id: '129FC1B0-9EB4-4763-8992-388FB31A049F',
      phenomenonTime: moment('2018-02-07T14:10:00.000+0000').toDate(),
      resultTime: moment('2018-02-07T14:17:31.795+0000').toDate(),
      value: -60.0847457627119,
      feature: 'EEM1',
      datastream: 'H10',
      uom: 'cm',
      datum: 'NAP',
      validityStart: null,
      validityEnd: null,
      results: {
        Distribution: 'passed',
        Count: 'passed',
      },
    },
  ],
  [
    {
      id: '87C0A376-E35D-4B71-8584-41A0CAD6006E',
      phenomenonTime: moment('2018-02-07T14:17:00.000+0000').toDate(),
      resultTime: moment('2018-02-07T14:17:45.512+0000').toDate(),
      value: -56.3333333333333,
      feature: 'EEM1',
      datastream: 'H01',
      uom: 'cm',
      datum: 'NAP',
      validityStart: null,
      validityEnd: null,
      results: {
        Distribution: 'passed',
        Count: 'passed',
      },
    },
  ],
];

export const mockMetaDataInterface: MetaDataInterface[] = [
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevel0.txt',
    location: 'Eemhaven',
    user: 'Samira',
    status: 'Succeeded',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevel1.txt',
    location: 'Vlaardingen',
    user: 'Samira',
    status: 'Succeeded',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevel2.txt',
    location: 'Eemhaven',
    user: 'Samira',
    status: 'Failed',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevel3.txt',
    location: 'Eemhaven',
    user: 'Samira',
    status: 'Succeeded',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevel4.txt',
    location: 'Eemhaven',
    user: 'Samira',
    status: 'Succeeded',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevel5.txt',
    location: 'Vlaardingen',
    user: 'Samira',
    status: 'Failed',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevel6.txt',
    location: 'Vlaardingen',
    user: 'Samira',
    status: 'Succeeded',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevel7.txt',
    location: 'Eemhaven',
    user: 'Samira',
    status: 'Succeeded',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevel8.txt',
    location: 'Eemhaven',
    user: 'Samira',
    status: 'Failed',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevel9.txt',
    location: 'Eemhaven',
    user: 'Samira',
    status: 'Succeeded',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevela.txt',
    location: 'Eemhaven',
    user: 'Jack',
    status: 'Failed',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevelb.txt',
    location: 'Vlaardingen',
    user: 'Jack',
    status: 'Succeeded',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
  {
    dateTime: '2018-01-17 15:40:46.0',
    fileType: 'waterlevel',
    name: 'waterlevelc.txt',
    location: 'Vlaardingen',
    user: 'Jack',
    status: 'Succeeded',
    message: 'message',
    getDate() {
      return new Date('2018-01-17 15:40:46.0');
    },
  },
];

export const mockSensorNameValidator: SensorSummary[] = [
  {name: 'H-S-TEST-0'} as SensorSummary,
  {name: 'H-S-TEST-1'} as SensorSummary,
  {name: 'H-S-TEST-2'} as SensorSummary,
  {name: 'H-S-TEST-3'} as SensorSummary,
  {name: 'H-S-TEST-4'} as SensorSummary,
  {name: 'H-S-TEST-5'} as SensorSummary,
  {name: 'H-S-TEST-6'} as SensorSummary,
  {name: 'H-S-TEST-7'} as SensorSummary,
  {name: 'H-S-TEST-8'} as SensorSummary,
  {name: 'H-S-TEST-9'} as SensorSummary,
];

export const mockMyParseFloat = [
  ['-16.14', -16.14],
  ['-0.1', -0.1],
  ['0.1', 0.1],
  ['-0', 0],
  ['0', 0],
  ['+0', 0],
  ['+0.197', 0.197],
  ['99', 99],
  ['1024.42', 1024.42],
  [NaN, null],
];

export const mockEncodedJwtResponse = {
  access_token: null,
  token_type: 'bearer',
  expires_in: 3600,
  refresh_token: null,
};

export const mockDecodedJwtResponse = {
  aud: 'microsoft:identityserver:hbr-hm-api-dev',
  iss: 'http://fs.portofrotterdam.com/adfs/services/trust',
  iat: 1524478117,
  exp: 1524484529,
  email: 'rajm.best@portofrotterdam.com',
  unique_name: 'Best, Rob de',
  certsubjectkeyidentifier: 'POR\\D&IT\\DE',
  role: [
    'Externen',
    'HM_SensorMgr',
  ],
  auth_time: '2018-04-23T10:08:37.473Z',
  authmethod: 'urn:oasis:names:tc:SAML:2.0:ac:classes:PasswordProtectedTransport',
  ver: '1.0',
  appid: 'hbr-hm-administration-ui-dev',
  jti: '04c707aa-6a5b-49d4-8efb-54935619ad19',
};

export const mockPaginationProperties: PaginationProperties = paginationObject;

export const mockPaginationClikNext = {
  displayedData: [
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:49:34+02:00',
      timeString: '23:49',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing on',
      reason: 'publishing on',
      actionTime: '2018-05-01T23:48:14+02:00',
      timeString: '23:48',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:48:04+02:00',
      timeString: '23:48',
    },
  ],
  page: 1,
  pages: [
    0,
    1,
  ],
  maxPage: 2,
  isPreviousButtonDisabled: false,
  isNextButtonDisabled: true,
  step: 10,
  steps: [
    10,
    20,
    50,
    100,
  ],
  filteredData: [
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-03T00:23:32+02:00',
      timeString: '00:23',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing',
      reason: 'publishing on',
      actionTime: '2018-05-03T00:06:25+02:00',
      timeString: '00:06',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-02T14:21:34+02:00',
      timeString: '14:21',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing',
      reason: 'publishing on',
      actionTime: '2018-05-02T14:20:47+02:00',
      timeString: '14:20',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-02T14:19:37+02:00',
      timeString: '14:19',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing',
      reason: 'publishing on',
      actionTime: '2018-05-02T14:15:22+02:00',
      timeString: '14:15',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-02T14:09:29+02:00',
      timeString: '14:09',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing on',
      reason: 'publishing on',
      actionTime: '2018-05-01T23:53:06+02:00',
      timeString: '23:53',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:51:42+02:00',
      timeString: '23:51',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing on',
      reason: 'publishing on',
      actionTime: '2018-05-01T23:51:18+02:00',
      timeString: '23:51',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:49:34+02:00',
      timeString: '23:49',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing on',
      reason: 'publishing on',
      actionTime: '2018-05-01T23:48:14+02:00',
      timeString: '23:48',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:48:04+02:00',
      timeString: '23:48',
    },
  ],
};

export const mockSearchDataByKeyword = {
  displayedData: [
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-03T00:23:32+02:00',
      timeString: '00:23',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-02T14:21:34+02:00',
      timeString: '14:21',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-02T14:19:37+02:00',
      timeString: '14:19',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-02T14:09:29+02:00',
      timeString: '14:09',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:51:42+02:00',
      timeString: '23:51',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:49:34+02:00',
      timeString: '23:49',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:48:04+02:00',
      timeString: '23:48',
    },
  ],
  page: 0,
  pages: [
    0,
  ],
  maxPage: 1,
  isPreviousButtonDisabled: true,
  isNextButtonDisabled: true,
  step: 10,
  steps: [
    10,
    20,
    50,
    100,
  ],
  filteredData: [
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-03T00:23:32+02:00',
      timeString: '00:23',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-02T14:21:34+02:00',
      timeString: '14:21',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-02T14:19:37+02:00',
      timeString: '14:19',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'not publishing',
      reason: 'publishing off',
      actionTime: '2018-05-02T14:09:29+02:00',
      timeString: '14:09',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:51:42+02:00',
      timeString: '23:51',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:49:34+02:00',
      timeString: '23:49',
    },
    {
      user: 'Janssen, Jan',
      actionTaken: 'publishing off',
      reason: 'publishing off',
      actionTime: '2018-05-01T23:48:04+02:00',
      timeString: '23:48',
    },
  ],
};

export const mockAstroUpload = [
  {
    name: 'timeseries_good.txt',
    status: 'SUCCEEDED',
    dateTime: '2018-05-09 13:40:07.0',
    message: 'File succesfully processed',
    fileType: 'Timeseries',
    location: 'Eemhaven | 1EEMH',
    user: 'Daan van Driel',
    time: '13:40:07',
  },
  {
    name: 'Boerengat tijdreeks 01012018-01072018 (1).txt',
    status: 'SUCCEEDED',
    dateTime: '2018-05-08 15:06:21.0',
    message: 'File succesfully processed',
    fileType: 'Timeseries',
    location: 'Boerengat | BOER',
    user: 'daan',
    time: '15:06:21',
  },
];

export const mockOsrUpload = [
  {
    name: 'osr_gt_iot.txt',
    status: 'SUCCESS',
    message: 'File succesfully processed',
    source: 'MX_DEV',
    quantity: '229',
    dateTime: '2018-05-07 11:44:59.0',
    time: '11:44:59',
  },
];

export const mockRwsUpload = [
  {
    locationNamePoR: 'WERK',
    locationCodeRWS: 'WERK',
    source: 'RWS',
    parameters: 1,
    items: [
      {
        propertyCodePoR: 'H10',
        parameterCodeRWS: 'H10',
        status: 'Succeeded',
        lastUpdate: '05/14/2018 12:20:00',
        lastImport: '05/14/2018 14:20:21',
      },
    ],
    status: 'Succeeded',
    lastUpdate: '05/14/2018 12:20:00',
    lastImport: '05/14/2018 14:20:21',
  },
];

export const mockFeatureList = [
  {
    id: '2B2271C8-B3EE-4968-A2B0-C3FE9EFE252D',
    name: 'SUURB25m',
    description: 'Suurhoffbrug 25 meter ',
    wkid: 28992,
    x: 66976,
    y: 439548,
    z: -6,
    active: true,
    endDate: new Date('2020-12-31T23:00:00.000'),
    processes: [
      {
        id: '5D4FCA48-B169-3504-9BCE-71749C525A5C',
        name: 'Tidal stream maximum POR process for SUURB25m',
        description: 'Tidal stream maximum POR process for Suurhoffbrug 25 meter (POR)',
        processType: {
          id: 'DCE1A8B2-D14E-491B-B752-C6E2517389D9',
          name: 'Tidal stream maximum POR',
          description: 'Tidal stream maximum POR',
          source: 'POR',
          resultsSet: false,
          sensorType: {
            id: '4FB8DA0C-C715-4235-B960-C1531605F470',
            name: 'Tidal Stream',
            description: 'Tidal Stream Sensor',
            deviceType: 'tidalstream',
            content: [],
            links: [],
          },
          propertyType: {
            id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
            name: 'CURR',
            description: 'Tidal stream (stroming)',
            content: [],
            links: [],
          },
          content: [],
          links: [],
        },
        datastreams: [
          {
            id: 'FC061CCE-B2BA-42DE-B408-CB55FA8EF202',
            checks: [],
            property: {
              id: '7A078F2F-021F-45B9-A4FD-19736868E1A8',
              name: 'MXS',
              description: 'Tidal stream maximum',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                name: 'm/s',
                description: 'Speed in metres per second',
                quantity: 'Speed',
                uomConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: 'A7D1EC5B-0B45-4A54-8708-54DF39851F29',
              property: {
                id: '7A078F2F-021F-45B9-A4FD-19736868E1A8',
                name: 'MXS',
                description: 'Tidal stream maximum',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
        ],
        sensorName: 'H-S-MNS-SUUR-ADCP',
        content: [],
        links: [
          {
            rel: 'feature',
            href: 'http://localhost:8080/api/v1/features/2B2271C8-B3EE-4968-A2B0-C3FE9EFE252D',
          },
        ],
      },
      {
        id: '8D51D17E-DDF2-3176-9536-29C7DD14F870',
        name: 'Tidal stream 10 minutes POR process for SUURB25m',
        description: 'Tidal stream 10 minutes POR process for Suurhoffbrug 25 meter (POR)',
        processType: {
          id: 'D3B3BD5D-EBE8-4649-8F69-19C5F726CCC5',
          name: 'Tidal stream 10 minutes POR',
          description: 'Tidal stream 10 minutes POR',
          source: 'POR',
          resultsSet: false,
          method: 'Vector Aggregate',
          interval: 600,
          sensorType: {
            id: '4FB8DA0C-C715-4235-B960-C1531605F470',
            name: 'Tidal Stream',
            description: 'Tidal Stream Sensor',
            deviceType: 'tidalstream',
            content: [],
            links: [],
          },
          propertyType: {
            id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
            name: 'CURR',
            description: 'Tidal stream (stroming)',
            content: [],
            links: [],
          },
          content: [],
          links: [],
        },
        datastreams: [
          {
            id: '42F98BA2-5CE3-4DBB-A3F9-AF5060F36B3E',
            checks: [
              {
                id: '42F98BA2-5CE3-4DBB-A3F9-AF5060F36B3E-1',
                checkTypeName: 'Distribution',
                active: true,
                unitOfMeasurement: {
                  id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                  name: 'deg',
                  description: 'Direction',
                  quantity: 'Direction',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: null,
                name: 'Distribution',
                params: [
                  {
                    name: 'value',
                    value: '121.0',
                  },
                ],
                content: [],
                links: [],
              },
              {
                id: '42F98BA2-5CE3-4DBB-A3F9-AF5060F36B3E-2',
                checkTypeName: 'Count',
                active: true,
                unitOfMeasurement: {
                  id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                  name: 'deg',
                  description: 'Direction',
                  quantity: 'Direction',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: null,
                name: 'Count',
                params: [
                  {
                    name: 'value',
                    value: '9.0',
                  },
                ],
                content: [],
                links: [],
              },
            ],
            property: {
              id: '15049EA7-D0E5-41E0-A139-DC3213F3909C',
              name: 'TSD10',
              description: 'Tidal stream direction 10 minutes ',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                name: 'deg',
                description: 'Direction',
                quantity: 'Direction',
                uomConversions: [],
                content: [],
                links: [],
              },
              datum: {
                id: '4735D5EF-20CA-4D37-9178-E739F94D48CA',
                name: 'Ntrue',
                description: 'True north',
                type: 'Direction',
                value: 'Ntrue',
                epsg: 0,
                datumConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: '5317DF78-409C-47EA-A7C8-0EC74E15DA69',
              property: {
                id: '15049EA7-D0E5-41E0-A139-DC3213F3909C',
                name: 'TSD10',
                description: 'Tidal stream direction 10 minutes ',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                  name: 'deg',
                  description: 'Direction',
                  quantity: 'Direction',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: {
                  id: '4735D5EF-20CA-4D37-9178-E739F94D48CA',
                  name: 'Ntrue',
                  description: 'True north',
                  type: 'Direction',
                  value: 'Ntrue',
                  epsg: 0,
                  datumConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
          {
            id: '242E3C17-26E7-4D27-1717-8C68A3768B67',
            checks: [
              {
                id: '242E3C17-26E7-4D27-1717-8C68A3768B67-1',
                checkTypeName: 'Distribution',
                active: true,
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: null,
                name: 'Distribution',
                params: [
                  {
                    name: 'value',
                    value: '121.0',
                  },
                ],
                content: [],
                links: [],
              },
              {
                id: '242E3C17-26E7-4D27-1717-8C68A3768B67-2',
                checkTypeName: 'Count',
                active: true,
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: null,
                name: 'Count',
                params: [
                  {
                    name: 'value',
                    value: '9.0',
                  },
                ],
                content: [],
                links: [],
              },
            ],
            property: {
              id: '79C88856-024C-4077-90EA-DFD8BCA947CF',
              name: 'TSR10',
              description: 'Tidal stream rate 10 minutes ',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                name: 'm/s',
                description: 'Speed in metres per second',
                quantity: 'Speed',
                uomConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: '0958FA11-C76E-417A-B835-58309AA40BBD',
              property: {
                id: '79C88856-024C-4077-90EA-DFD8BCA947CF',
                name: 'TSR10',
                description: 'Tidal stream rate 10 minutes ',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
        ],
        sensorName: 'H-S-MNS-SUUR-ADCP',
        content: [],
        links: [
          {
            rel: 'feature',
            href: 'http://localhost:8080/api/v1/features/2B2271C8-B3EE-4968-A2B0-C3FE9EFE252D',
          },
        ],
      },
      {
        id: '20360C36-465A-3BEE-BC53-A0B90C485972',
        name: 'Tidal stream 1 minute POR process for SUURB25m',
        description: 'Tidal stream 1 minute POR process for Suurhoffbrug 25 meter (POR)',
        processType: {
          id: 'CA82EBE6-5AD2-47E0-99AA-AC6556D38DBD',
          name: 'Tidal stream 1 minute POR',
          description: 'Tidal stream 1 minute POR',
          source: 'POR',
          resultsSet: false,
          method: 'Measured',
          interval: 60,
          sensorType: {
            id: '4FB8DA0C-C715-4235-B960-C1531605F470',
            name: 'Tidal Stream',
            description: 'Tidal Stream Sensor',
            deviceType: 'tidalstream',
            content: [],
            links: [],
          },
          propertyType: {
            id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
            name: 'CURR',
            description: 'Tidal stream (stroming)',
            content: [],
            links: [],
          },
          content: [],
          links: [],
        },
        datastreams: [
          {
            id: '694BD766-1592-49E4-AE45-C8E075846A6D',
            checks: [
              {
                id: '694BD766-1592-49E4-AE45-C8E075846A6D-1',
                checkTypeName: 'Extreme',
                active: true,
                unitOfMeasurement: {
                  id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                  name: 'deg',
                  description: 'Direction',
                  quantity: 'Direction',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: {
                  id: '4735D5EF-20CA-4D37-9178-E739F94D48CA',
                  name: 'Ntrue',
                  description: 'True north',
                  type: 'Direction',
                  value: 'Ntrue',
                  epsg: 0,
                  datumConversions: [],
                  content: [],
                  links: [],
                },
                name: 'Extreme',
                params: [
                  {
                    name: 'max',
                    value: '360.0',
                  },
                  {
                    name: 'min',
                    value: '0.0',
                  },
                ],
                content: [],
                links: [],
              },
            ],
            property: {
              id: '3050D472-6D2B-4705-80FD-471DA1DD07F0',
              name: 'TSD01',
              description: 'Tidal stream direction 1 minute ',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                name: 'deg',
                description: 'Direction',
                quantity: 'Direction',
                uomConversions: [],
                content: [],
                links: [],
              },
              datum: {
                id: '4735D5EF-20CA-4D37-9178-E739F94D48CA',
                name: 'Ntrue',
                description: 'True north',
                type: 'Direction',
                value: 'Ntrue',
                epsg: 0,
                datumConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: '8CE3DAFF-A531-465B-AD93-BCC5071EFF91',
              property: {
                id: '3050D472-6D2B-4705-80FD-471DA1DD07F0',
                name: 'TSD01',
                description: 'Tidal stream direction 1 minute ',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                  name: 'deg',
                  description: 'Direction',
                  quantity: 'Direction',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: {
                  id: '4735D5EF-20CA-4D37-9178-E739F94D48CA',
                  name: 'Ntrue',
                  description: 'True north',
                  type: 'Direction',
                  value: 'Ntrue',
                  epsg: 0,
                  datumConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
          {
            id: '694FCECA-910C-1948-69F9-EAA18D3897EE',
            checks: [
              {
                id: '694FCECA-910C-1948-69F9-EAA18D3897EE-1',
                checkTypeName: 'Extreme',
                active: true,
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: null,
                name: 'Extreme',
                params: [
                  {
                    name: 'max',
                    value: '3.0',
                  },
                  {
                    name: 'min',
                    value: '0.0',
                  },
                ],
                content: [],
                links: [],
              },
            ],
            property: {
              id: 'D0155167-B3AB-4077-8A65-D7356C7361DC',
              name: 'TSR01',
              description: 'Tidal stream rate 1 minute ',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                name: 'm/s',
                description: 'Speed in metres per second',
                quantity: 'Speed',
                uomConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: '94694A80-EC9A-424A-9E44-7CA6B712429C',
              property: {
                id: 'D0155167-B3AB-4077-8A65-D7356C7361DC',
                name: 'TSR01',
                description: 'Tidal stream rate 1 minute ',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
        ],
        sensorName: 'H-S-MNS-SUUR-ADCP',
        content: [],
        links: [
          {
            rel: 'feature',
            href: 'http://localhost:8080/api/v1/features/2B2271C8-B3EE-4968-A2B0-C3FE9EFE252D',
          },
        ],
      },
      {
        id: '4515EC29-7B69-34F8-9AA6-971BA4093902',
        name: 'Slack Water POR process for SUURB25m',
        description: 'Slack Water POR process for Suurhoffbrug 25 meter (POR)',
        processType: {
          id: '7E1670CB-834F-4B2F-8F21-EF79C9FDB9E0',
          name: 'Slack Water POR',
          description: 'Slack Water POR',
          source: 'POR',
          resultsSet: false,
          sensorType: {
            id: '4FB8DA0C-C715-4235-B960-C1531605F470',
            name: 'Tidal Stream',
            description: 'Tidal Stream Sensor',
            deviceType: 'tidalstream',
            content: [],
            links: [],
          },
          propertyType: {
            id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
            name: 'CURR',
            description: 'Tidal stream (stroming)',
            content: [],
            links: [],
          },
          content: [],
          links: [],
        },
        datastreams: [
          {
            id: 'FA6164D5-CE26-48F2-8EA8-4588BCC8C383',
            checks: [],
            property: {
              id: '44C1742B-211F-481C-BF1D-5E80A7367C32',
              name: 'SLW',
              description: 'Slack water',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                name: 'm/s',
                description: 'Speed in metres per second',
                quantity: 'Speed',
                uomConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: '832F499C-E4D1-4336-996B-CFB7F3B391B7',
              property: {
                id: '44C1742B-211F-481C-BF1D-5E80A7367C32',
                name: 'SLW',
                description: 'Slack water',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
        ],
        sensorName: 'H-S-MNS-SUUR-ADCP',
        content: [],
        links: [
          {
            rel: 'feature',
            href: 'http://localhost:8080/api/v1/features/2B2271C8-B3EE-4968-A2B0-C3FE9EFE252D',
          },
        ],
      },
    ],
  },
  {
    id: '9611CCA7-9668-4BAC-93DB-FE1E713704E9',
    name: 'SUURB55m',
    description: 'Suurhoffbrug 55 meter ',
    wkid: 28992,
    x: 66970,
    y: 439518,
    z: -6,
    active: true,
    endDate: new Date('2020-12-31T23:00:00.000'),
    processes: [
      {
        id: 'C3B8FA92-38EB-3CF0-8BDC-88311DCBF9AD',
        name: 'Tidal stream 1 minute POR process for SUURB55m',
        description: 'Tidal stream 1 minute POR process for Suurhoffbrug 55 meter (POR)',
        processType: {
          id: 'CA82EBE6-5AD2-47E0-99AA-AC6556D38DBD',
          name: 'Tidal stream 1 minute POR',
          description: 'Tidal stream 1 minute POR',
          source: 'POR',
          resultsSet: false,
          method: 'Measured',
          interval: 60,
          sensorType: {
            id: '4FB8DA0C-C715-4235-B960-C1531605F470',
            name: 'Tidal Stream',
            description: 'Tidal Stream Sensor',
            deviceType: 'tidalstream',
            content: [],
            links: [],
          },
          propertyType: {
            id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
            name: 'CURR',
            description: 'Tidal stream (stroming)',
            content: [],
            links: [],
          },
          content: [],
          links: [],
        },
        datastreams: [
          {
            id: 'B2E940FF-8C18-4D48-A7AF-B9327975D3FC',
            checks: [
              {
                id: 'B2E940FF-8C18-4D48-A7AF-B9327975D3FC-1',
                checkTypeName: 'Extreme',
                active: true,
                unitOfMeasurement: {
                  id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                  name: 'deg',
                  description: 'Direction',
                  quantity: 'Direction',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: {
                  id: '4735D5EF-20CA-4D37-9178-E739F94D48CA',
                  name: 'Ntrue',
                  description: 'True north',
                  type: 'Direction',
                  value: 'Ntrue',
                  epsg: 0,
                  datumConversions: [],
                  content: [],
                  links: [],
                },
                name: 'Extreme',
                params: [
                  {
                    name: 'max',
                    value: '360.0',
                  },
                  {
                    name: 'min',
                    value: '0.0',
                  },
                ],
                content: [],
                links: [],
              },
            ],
            property: {
              id: '3050D472-6D2B-4705-80FD-471DA1DD07F0',
              name: 'TSD01',
              description: 'Tidal stream direction 1 minute ',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                name: 'deg',
                description: 'Direction',
                quantity: 'Direction',
                uomConversions: [],
                content: [],
                links: [],
              },
              datum: {
                id: '4735D5EF-20CA-4D37-9178-E739F94D48CA',
                name: 'Ntrue',
                description: 'True north',
                type: 'Direction',
                value: 'Ntrue',
                epsg: 0,
                datumConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: '8CE3DAFF-A531-465B-AD93-BCC5071EFF91',
              property: {
                id: '3050D472-6D2B-4705-80FD-471DA1DD07F0',
                name: 'TSD01',
                description: 'Tidal stream direction 1 minute ',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                  name: 'deg',
                  description: 'Direction',
                  quantity: 'Direction',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: {
                  id: '4735D5EF-20CA-4D37-9178-E739F94D48CA',
                  name: 'Ntrue',
                  description: 'True north',
                  type: 'Direction',
                  value: 'Ntrue',
                  epsg: 0,
                  datumConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
          {
            id: '29E77641-0736-204A-24CA-EB5CB2E13C98',
            checks: [
              {
                id: '29E77641-0736-204A-24CA-EB5CB2E13C98-1',
                checkTypeName: 'Extreme',
                active: true,
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: null,
                name: 'Extreme',
                params: [
                  {
                    name: 'max',
                    value: '3.0',
                  },
                  {
                    name: 'min',
                    value: '0.0',
                  },
                ],
                content: [],
                links: [],
              },
            ],
            property: {
              id: 'D0155167-B3AB-4077-8A65-D7356C7361DC',
              name: 'TSR01',
              description: 'Tidal stream rate 1 minute ',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                name: 'm/s',
                description: 'Speed in metres per second',
                quantity: 'Speed',
                uomConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: '94694A80-EC9A-424A-9E44-7CA6B712429C',
              property: {
                id: 'D0155167-B3AB-4077-8A65-D7356C7361DC',
                name: 'TSR01',
                description: 'Tidal stream rate 1 minute ',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
        ],
        sensorName: 'H-S-MNS-SUUR-ADCP',
        content: [],
        links: [
          {
            rel: 'feature',
            href: 'http://localhost:8080/api/v1/features/9611CCA7-9668-4BAC-93DB-FE1E713704E9',
          },
        ],
      },
      {
        id: '2592162F-2768-3271-BB41-E9C9A4BFBF7F',
        name: 'Slack Water POR process for SUURB55m',
        description: 'Slack Water POR process for Suurhoffbrug 55 meter (POR)',
        processType: {
          id: '7E1670CB-834F-4B2F-8F21-EF79C9FDB9E0',
          name: 'Slack Water POR',
          description: 'Slack Water POR',
          source: 'POR',
          resultsSet: false,
          sensorType: {
            id: '4FB8DA0C-C715-4235-B960-C1531605F470',
            name: 'Tidal Stream',
            description: 'Tidal Stream Sensor',
            deviceType: 'tidalstream',
            content: [],
            links: [],
          },
          propertyType: {
            id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
            name: 'CURR',
            description: 'Tidal stream (stroming)',
            content: [],
            links: [],
          },
          content: [],
          links: [],
        },
        datastreams: [
          {
            id: '1B580ED3-C4F7-4FFC-ABF2-3DA18ADB9B22',
            checks: [],
            property: {
              id: '44C1742B-211F-481C-BF1D-5E80A7367C32',
              name: 'SLW',
              description: 'Slack water',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                name: 'm/s',
                description: 'Speed in metres per second',
                quantity: 'Speed',
                uomConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: '832F499C-E4D1-4336-996B-CFB7F3B391B7',
              property: {
                id: '44C1742B-211F-481C-BF1D-5E80A7367C32',
                name: 'SLW',
                description: 'Slack water',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
        ],
        sensorName: 'H-S-MNS-SUUR-ADCP',
        content: [],
        links: [
          {
            rel: 'feature',
            href: 'http://localhost:8080/api/v1/features/9611CCA7-9668-4BAC-93DB-FE1E713704E9',
          },
        ],
      },
      {
        id: '4BBCF5D9-E5F2-39FD-ACD4-EEEC9A994C1F',
        name: 'Tidal stream maximum POR process for SUURB55m',
        description: 'Tidal stream maximum POR process for Suurhoffbrug 55 meter (POR)',
        processType: {
          id: 'DCE1A8B2-D14E-491B-B752-C6E2517389D9',
          name: 'Tidal stream maximum POR',
          description: 'Tidal stream maximum POR',
          source: 'POR',
          resultsSet: false,
          sensorType: {
            id: '4FB8DA0C-C715-4235-B960-C1531605F470',
            name: 'Tidal Stream',
            description: 'Tidal Stream Sensor',
            deviceType: 'tidalstream',
            content: [],
            links: [],
          },
          propertyType: {
            id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
            name: 'CURR',
            description: 'Tidal stream (stroming)',
            content: [],
            links: [],
          },
          content: [],
          links: [],
        },
        datastreams: [
          {
            id: 'E2F28549-6FA1-47C2-935B-72F53097523B',
            checks: [],
            property: {
              id: '7A078F2F-021F-45B9-A4FD-19736868E1A8',
              name: 'MXS',
              description: 'Tidal stream maximum',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                name: 'm/s',
                description: 'Speed in metres per second',
                quantity: 'Speed',
                uomConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: 'A7D1EC5B-0B45-4A54-8708-54DF39851F29',
              property: {
                id: '7A078F2F-021F-45B9-A4FD-19736868E1A8',
                name: 'MXS',
                description: 'Tidal stream maximum',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
        ],
        sensorName: 'H-S-MNS-SUUR-ADCP',
        content: [],
        links: [
          {
            rel: 'feature',
            href: 'http://localhost:8080/api/v1/features/9611CCA7-9668-4BAC-93DB-FE1E713704E9',
          },
        ],
      },
      {
        id: '3FD219B7-E9DA-3AD2-B5AD-F293EE9F5540',
        name: 'Tidal stream 10 minutes POR process for SUURB55m',
        description: 'Tidal stream 10 minutes POR process for Suurhoffbrug 55 meter (POR)',
        processType: {
          id: 'D3B3BD5D-EBE8-4649-8F69-19C5F726CCC5',
          name: 'Tidal stream 10 minutes POR',
          description: 'Tidal stream 10 minutes POR',
          source: 'POR',
          resultsSet: false,
          method: 'Vector Aggregate',
          interval: 600,
          sensorType: {
            id: '4FB8DA0C-C715-4235-B960-C1531605F470',
            name: 'Tidal Stream',
            description: 'Tidal Stream Sensor',
            deviceType: 'tidalstream',
            content: [],
            links: [],
          },
          propertyType: {
            id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
            name: 'CURR',
            description: 'Tidal stream (stroming)',
            content: [],
            links: [],
          },
          content: [],
          links: [],
        },
        datastreams: [
          {
            id: '9A17FAB3-712E-40CB-8FC3-5A0826939FD4',
            checks: [
              {
                id: '9A17FAB3-712E-40CB-8FC3-5A0826939FD4-2',
                checkTypeName: 'Count',
                active: true,
                unitOfMeasurement: {
                  id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                  name: 'deg',
                  description: 'Direction',
                  quantity: 'Direction',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: null,
                name: 'Count',
                params: [
                  {
                    name: 'value',
                    value: '9.0',
                  },
                ],
                content: [],
                links: [],
              },
              {
                id: '9A17FAB3-712E-40CB-8FC3-5A0826939FD4-1',
                checkTypeName: 'Distribution',
                active: true,
                unitOfMeasurement: {
                  id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                  name: 'deg',
                  description: 'Direction',
                  quantity: 'Direction',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: null,
                name: 'Distribution',
                params: [
                  {
                    name: 'value',
                    value: '121.0',
                  },
                ],
                content: [],
                links: [],
              },
            ],
            property: {
              id: '15049EA7-D0E5-41E0-A139-DC3213F3909C',
              name: 'TSD10',
              description: 'Tidal stream direction 10 minutes ',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                name: 'deg',
                description: 'Direction',
                quantity: 'Direction',
                uomConversions: [],
                content: [],
                links: [],
              },
              datum: {
                id: '4735D5EF-20CA-4D37-9178-E739F94D48CA',
                name: 'Ntrue',
                description: 'True north',
                type: 'Direction',
                value: 'Ntrue',
                epsg: 0,
                datumConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: '5317DF78-409C-47EA-A7C8-0EC74E15DA69',
              property: {
                id: '15049EA7-D0E5-41E0-A139-DC3213F3909C',
                name: 'TSD10',
                description: 'Tidal stream direction 10 minutes ',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '067E4FA4-9C14-4DC2-8B45-C3C5B25F7345',
                  name: 'deg',
                  description: 'Direction',
                  quantity: 'Direction',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: {
                  id: '4735D5EF-20CA-4D37-9178-E739F94D48CA',
                  name: 'Ntrue',
                  description: 'True north',
                  type: 'Direction',
                  value: 'Ntrue',
                  epsg: 0,
                  datumConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
          {
            id: 'E060545B-5D73-442F-17AA-98C2771D4830',
            checks: [
              {
                id: 'E060545B-5D73-442F-17AA-98C2771D4830-1',
                checkTypeName: 'Distribution',
                active: true,
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: null,
                name: 'Distribution',
                params: [
                  {
                    name: 'value',
                    value: '121.0',
                  },
                ],
                content: [],
                links: [],
              },
              {
                id: 'E060545B-5D73-442F-17AA-98C2771D4830-2',
                checkTypeName: 'Count',
                active: true,
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                datum: null,
                name: 'Count',
                params: [
                  {
                    name: 'value',
                    value: '9.0',
                  },
                ],
                content: [],
                links: [],
              },
            ],
            property: {
              id: '79C88856-024C-4077-90EA-DFD8BCA947CF',
              name: 'TSR10',
              description: 'Tidal stream rate 10 minutes ',
              propertyType: {
                id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                name: 'CURR',
                description: 'Tidal stream (stroming)',
                content: [],
                links: [],
              },
              unitOfMeasurement: {
                id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                name: 'm/s',
                description: 'Speed in metres per second',
                quantity: 'Speed',
                uomConversions: [],
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            datastreamType: {
              id: '0958FA11-C76E-417A-B835-58309AA40BBD',
              property: {
                id: '79C88856-024C-4077-90EA-DFD8BCA947CF',
                name: 'TSR10',
                description: 'Tidal stream rate 10 minutes ',
                propertyType: {
                  id: '5B66BE56-3777-4F63-997D-0C5F1B3A1426',
                  name: 'CURR',
                  description: 'Tidal stream (stroming)',
                  content: [],
                  links: [],
                },
                unitOfMeasurement: {
                  id: '872C53A7-EF7D-4837-B136-1A668937D1B4',
                  name: 'm/s',
                  description: 'Speed in metres per second',
                  quantity: 'Speed',
                  uomConversions: [],
                  content: [],
                  links: [],
                },
                content: [],
                links: [],
              },
              content: [],
              links: [],
            },
            content: [],
            links: [],
          },
        ],
        sensorName: 'H-S-MNS-SUUR-ADCP',
        content: [],
        links: [
          {
            rel: 'feature',
            href: 'http://localhost:8080/api/v1/features/9611CCA7-9668-4BAC-93DB-FE1E713704E9',
          },
        ],
      },
    ],
  },
];

export const mockFeatureDatastreamForCheck = [
  {
    id: '3CD91780-50ED-4A97-926B-EA55B2CD73EC',
    checks: [
      {
        id: '7AE3352D-7434-4709-883B-5F18E5057121',
        checkTypeName: 'Count',
        active: true,
        unitOfMeasurement: {
          id: '3D60066B-45E3-4173-8BCF-33C578A3DE9F',
          name: 's',
          description: 'Second',
          quantity: 'Time',
          uomConversions: [],
          content: [],
          links: [],
        },
        datum: null,
        name: 'Count',
        params: [
          {
            name: 'value',
            value: '5.0',
          },
        ],
        content: [],
        links: [],
      },
      {
        id: 'C6D12AC0-ED76-4234-8449-14BCCFFB0999',
        checkTypeName: 'Distribution',
        active: true,
        unitOfMeasurement: {
          id: '3D60066B-45E3-4173-8BCF-33C578A3DE9F',
          name: 's',
          description: 'Second',
          quantity: 'Time',
          uomConversions: [],
          content: [],
          links: [],
        },
        datum: null,
        name: 'Distribution',
        params: [
          {
            name: 'value',
            value: '21.0',
          },
        ],
        content: [],
        links: [],
      },
    ],
    observations: [],
    property: {
      id: 'B998352E-A0C2-4F9F-B18B-E4E6E00784D5',
      name: 'H01',
      description: 'Height of tide 1 minute ',
      propertyType: {
        id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
        name: 'WLEV',
        description: 'Height of tide (waterstand)',
        content: [],
        links: [],
      },
      unitOfMeasurement: {
        id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
        name: 'cm',
        description: 'Distance\/length',
        quantity: 'Distance',
        uomConversions: [
          {
            id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
            fromUomName: 'cm',
            toUomName: 'm',
            content: [],
            links: [],
          },
        ],
        content: [],
        links: [],
      },
      datum: {
        id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
        name: 'NAP',
        description: 'Normaal Amsterdams Peil - average sea level',
        type: 'Height',
        value: 'NAP',
        epsg: 0,
        datumConversions: [
          {
            id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
            fromDatumName: 'NAP',
            toDatumName: 'ALAT',
            content: [],
            links: [],
          },
        ],
        content: [],
        links: [],
      },
      content: [],
      links: [],
    },
    datastreamType: {
      id: '1F8CAC32-BE0D-4092-8675-0273D8F9CD5E',
      property: {
        id: 'B998352E-A0C2-4F9F-B18B-E4E6E00784D5',
        name: 'H01',
        description: 'Height of tide 1 minute ',
        propertyType: {
          id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
          name: 'WLEV',
          description: 'Height of tide (waterstand)',
          content: [],
          links: [],
        },
        unitOfMeasurement: {
          id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
          name: 'cm',
          description: 'Distance\/length',
          quantity: 'Distance',
          uomConversions: [
            {
              id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
              fromUomName: 'cm',
              toUomName: 'm',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        datum: {
          id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
          name: 'NAP',
          description: 'Normaal Amsterdams Peil - average sea level',
          type: 'Height',
          value: 'NAP',
          epsg: 0,
          datumConversions: [
            {
              id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
              fromDatumName: 'NAP',
              toDatumName: 'ALAT',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        content: [],
        links: [],
      },
      content: [],
      links: [],
    },
    content: [],
    links: [],
  },
  {
    id: 'A3CBE672-3542-4B93-99BE-C254B9A9C953',
    checks: [
      {
        id: 'CC5E603A-371B-4F56-BFBA-FFC0EF3C59B1',
        checkTypeName: 'Delta',
        active: true,
        unitOfMeasurement: {
          id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
          name: 'cm',
          description: 'Distance\/length',
          quantity: 'Distance',
          uomConversions: [
            {
              id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
              fromUomName: 'cm',
              toUomName: 'm',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        datum: {
          id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
          name: 'NAP',
          description: 'Normaal Amsterdams Peil - average sea level',
          type: 'Height',
          value: 'NAP',
          epsg: 0,
          datumConversions: [
            {
              id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
              fromDatumName: 'NAP',
              toDatumName: 'ALAT',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        name: 'Delta',
        params: [
          {
            name: 'value',
            value: '15.0',
          },
        ],
        content: [],
        links: [],
      },
      {
        id: '65BFA584-2A92-4655-9900-969B94096BCF',
        checkTypeName: 'Extreme',
        active: true,
        unitOfMeasurement: {
          id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
          name: 'cm',
          description: 'Distance\/length',
          quantity: 'Distance',
          uomConversions: [
            {
              id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
              fromUomName: 'cm',
              toUomName: 'm',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        datum: {
          id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
          name: 'NAP',
          description: 'Normaal Amsterdams Peil - average sea level',
          type: 'Height',
          value: 'NAP',
          epsg: 0,
          datumConversions: [
            {
              id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
              fromDatumName: 'NAP',
              toDatumName: 'ALAT',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        name: 'Extreme',
        params: [
          {
            name: 'max',
            value: '400.0',
          },
          {
            name: 'min',
            value: '-200.0',
          },
        ],
        content: [],
        links: [],
      },
    ],
    observations: [],
    property: {
      id: '3032B0E4-56D1-4E40-87D0-ED32E577DA34',
      name: 'H10sec',
      description: 'Height of tide 10 seconds ',
      propertyType: {
        id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
        name: 'WLEV',
        description: 'Height of tide (waterstand)',
        content: [],
        links: [],
      },
      unitOfMeasurement: {
        id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
        name: 'cm',
        description: 'Distance\/length',
        quantity: 'Distance',
        uomConversions: [
          {
            id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
            fromUomName: 'cm',
            toUomName: 'm',
            content: [],
            links: [],
          },
        ],
        content: [],
        links: [],
      },
      datum: {
        id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
        name: 'NAP',
        description: 'Normaal Amsterdams Peil - average sea level',
        type: 'Height',
        value: 'NAP',
        epsg: 0,
        datumConversions: [
          {
            id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
            fromDatumName: 'NAP',
            toDatumName: 'ALAT',
            content: [],
            links: [],
          },
        ],
        content: [],
        links: [],
      },
      content: [],
      links: [],
    },
    datastreamType: {
      id: '68F2C16B-3134-4218-8F1F-1A99A8ED3873',
      property: {
        id: '3032B0E4-56D1-4E40-87D0-ED32E577DA34',
        name: 'H10sec',
        description: 'Height of tide 10 seconds ',
        propertyType: {
          id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
          name: 'WLEV',
          description: 'Height of tide (waterstand)',
          content: [],
          links: [],
        },
        unitOfMeasurement: {
          id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
          name: 'cm',
          description: 'Distance\/length',
          quantity: 'Distance',
          uomConversions: [
            {
              id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
              fromUomName: 'cm',
              toUomName: 'm',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        datum: {
          id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
          name: 'NAP',
          description: 'Normaal Amsterdams Peil - average sea level',
          type: 'Height',
          value: 'NAP',
          epsg: 0,
          datumConversions: [
            {
              id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
              fromDatumName: 'NAP',
              toDatumName: 'ALAT',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        content: [],
        links: [],
      },
      content: [],
      links: [],
    },
    content: [],
    links: [],
  },
  {
    id: '28D65503-8746-4789-AC70-6314539F41C3',
    checks: [
      {
        id: '33BFE0AD-2480-40FB-9F8C-A0867BA314A9',
        checkTypeName: 'Count',
        active: true,
        unitOfMeasurement: {
          id: '3D60066B-45E3-4173-8BCF-33C578A3DE9F',
          name: 's',
          description: 'Second',
          quantity: 'Time',
          uomConversions: [],
          content: [],
          links: [],
        },
        datum: null,
        name: 'Count',
        params: [
          {
            name: 'value',
            value: '54.0',
          },
        ],
        content: [],
        links: [],
      },
      {
        id: '4879F521-E9B1-4B68-BEE1-F6087E87E85C',
        checkTypeName: 'Distribution',
        active: true,
        unitOfMeasurement: {
          id: '3D60066B-45E3-4173-8BCF-33C578A3DE9F',
          name: 's',
          description: 'Second',
          quantity: 'Time',
          uomConversions: [],
          content: [],
          links: [],
        },
        datum: null,
        name: 'Distribution',
        params: [
          {
            name: 'value',
            value: '61.0',
          },
        ],
        content: [],
        links: [],
      },
    ],
    observations: [],
    property: {
      id: 'D696C336-3E65-4FEC-B334-D4DBF7F7E94B',
      name: 'H10',
      description: 'Height of tide 10 minutes ',
      propertyType: {
        id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
        name: 'WLEV',
        description: 'Height of tide (waterstand)',
        content: [],
        links: [],
      },
      unitOfMeasurement: {
        id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
        name: 'cm',
        description: 'Distance\/length',
        quantity: 'Distance',
        uomConversions: [
          {
            id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
            fromUomName: 'cm',
            toUomName: 'm',
            content: [],
            links: [],
          },
        ],
        content: [],
        links: [],
      },
      datum: {
        id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
        name: 'NAP',
        description: 'Normaal Amsterdams Peil - average sea level',
        type: 'Height',
        value: 'NAP',
        epsg: 0,
        datumConversions: [
          {
            id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
            fromDatumName: 'NAP',
            toDatumName: 'ALAT',
            content: [],
            links: [],
          },
        ],
        content: [],
        links: [],
      },
      content: [],
      links: [],
    },
    datastreamType: {
      id: '97D6AFF1-EA54-4005-A219-AA081B32F818',
      property: {
        id: 'D696C336-3E65-4FEC-B334-D4DBF7F7E94B',
        name: 'H10',
        description: 'Height of tide 10 minutes ',
        propertyType: {
          id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
          name: 'WLEV',
          description: 'Height of tide (waterstand)',
          content: [],
          links: [],
        },
        unitOfMeasurement: {
          id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
          name: 'cm',
          description: 'Distance\/length',
          quantity: 'Distance',
          uomConversions: [
            {
              id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
              fromUomName: 'cm',
              toUomName: 'm',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        datum: {
          id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
          name: 'NAP',
          description: 'Normaal Amsterdams Peil - average sea level',
          type: 'Height',
          value: 'NAP',
          epsg: 0,
          datumConversions: [
            {
              id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
              fromDatumName: 'NAP',
              toDatumName: 'ALAT',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        content: [],
        links: [],
      },
      content: [],
      links: [],
    },
    content: [],
    links: [],
  },
  {
    id: 'E8EE4456-E9A2-4A60-B7EB-E32F2A428712',
    checks: [],
    observations: [],
    property: {
      id: '65F35E2A-FA4E-4C40-A32C-844DA22BA8EC',
      name: 'HW',
      description: 'High water',
      propertyType: {
        id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
        name: 'WLEV',
        description: 'Height of tide (waterstand)',
        content: [],
        links: [],
      },
      unitOfMeasurement: {
        id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
        name: 'cm',
        description: 'Distance\/length',
        quantity: 'Distance',
        uomConversions: [
          {
            id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
            fromUomName: 'cm',
            toUomName: 'm',
            content: [],
            links: [],
          },
        ],
        content: [],
        links: [],
      },
      datum: {
        id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
        name: 'NAP',
        description: 'Normaal Amsterdams Peil - average sea level',
        type: 'Height',
        value: 'NAP',
        epsg: 0,
        datumConversions: [
          {
            id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
            fromDatumName: 'NAP',
            toDatumName: 'ALAT',
            content: [],
            links: [],
          },
        ],
        content: [],
        links: [],
      },
      content: [],
      links: [],
    },
    datastreamType: {
      id: '34C4F3BB-342C-485E-8287-CE3CE126630D',
      property: {
        id: '65F35E2A-FA4E-4C40-A32C-844DA22BA8EC',
        name: 'HW',
        description: 'High water',
        propertyType: {
          id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
          name: 'WLEV',
          description: 'Height of tide (waterstand)',
          content: [],
          links: [],
        },
        unitOfMeasurement: {
          id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
          name: 'cm',
          description: 'Distance\/length',
          quantity: 'Distance',
          uomConversions: [
            {
              id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
              fromUomName: 'cm',
              toUomName: 'm',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        datum: {
          id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
          name: 'NAP',
          description: 'Normaal Amsterdams Peil - average sea level',
          type: 'Height',
          value: 'NAP',
          epsg: 0,
          datumConversions: [
            {
              id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
              fromDatumName: 'NAP',
              toDatumName: 'ALAT',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        content: [],
        links: [],
      },
      content: [],
      links: [],
    },
    content: [],
    links: [],
  },
  {
    id: '07D71A4E-5EAA-4936-B487-E1D861E467BA',
    checks: [],
    observations: [],
    property: {
      id: '0CDA0FD5-8C5E-4F74-ADA4-E72144FEDF03',
      name: 'LW',
      description: 'Low water',
      propertyType: {
        id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
        name: 'WLEV',
        description: 'Height of tide (waterstand)',
        content: [],
        links: [],
      },
      unitOfMeasurement: {
        id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
        name: 'cm',
        description: 'Distance\/length',
        quantity: 'Distance',
        uomConversions: [
          {
            id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
            fromUomName: 'cm',
            toUomName: 'm',
            content: [],
            links: [],
          },
        ],
        content: [],
        links: [],
      },
      datum: {
        id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
        name: 'NAP',
        description: 'Normaal Amsterdams Peil - average sea level',
        type: 'Height',
        value: 'NAP',
        epsg: 0,
        datumConversions: [
          {
            id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
            fromDatumName: 'NAP',
            toDatumName: 'ALAT',
            content: [],
            links: [],
          },
        ],
        content: [],
        links: [],
      },
      content: [],
      links: [],
    },
    datastreamType: {
      id: 'A930E2B3-1895-46B2-A484-498244A72C15',
      property: {
        id: '0CDA0FD5-8C5E-4F74-ADA4-E72144FEDF03',
        name: 'LW',
        description: 'Low water',
        propertyType: {
          id: '551CA9D9-8FAB-FA4A-99F4-94A37AB2DC19',
          name: 'WLEV',
          description: 'Height of tide (waterstand)',
          content: [],
          links: [],
        },
        unitOfMeasurement: {
          id: '9FB84498-3E11-4960-9D71-B8D7F9255168',
          name: 'cm',
          description: 'Distance\/length',
          quantity: 'Distance',
          uomConversions: [
            {
              id: '2FDA3201-A320-49DC-B2ED-CB578B4AC766',
              fromUomName: 'cm',
              toUomName: 'm',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        datum: {
          id: '51C47F35-C5A3-CD41-A8CA-AA2BF579BB2C',
          name: 'NAP',
          description: 'Normaal Amsterdams Peil - average sea level',
          type: 'Height',
          value: 'NAP',
          epsg: 0,
          datumConversions: [
            {
              id: '83E42EF3-247A-4F69-9C48-EB261CBFE9B5',
              fromDatumName: 'NAP',
              toDatumName: 'ALAT',
              content: [],
              links: [],
            },
          ],
          content: [],
          links: [],
        },
        content: [],
        links: [],
      },
      content: [],
      links: [],
    },
    content: [],
    links: [],
  },
];

export const mockFeatureTypes: FeatureType[] = [
  new FeatureType('B0BDCEC0-FA99-4152-81CD-61C55DDAC277', 'Height of tide', 'Water level, high water and low water'),
  new FeatureType('6A704455-6AB1-461E-B8A9-4C6D69A61D62', 'Pressure', 'Air pressure'),
  new FeatureType('25539E2C-2FBA-4F60-8039-E99B067CC85A', 'Charted vertical clearance', 'Distance between water level and bottom of a bridge, crane etc.'),
  new FeatureType('1AC19AF1-2637-4B46-953B-C376E303AF9F', 'Humidity', 'Relative humidity'),
  new FeatureType('F9E0956B-306D-466C-8587-01D55D92C875', 'River flow', 'Volume of water flow (discharge) of a river'),
  new FeatureType('219BA890-2738-4476-8B62-21845FFD44FC', 'Temperature', 'Air and water temperature'),
  new FeatureType('84C28A53-2B0D-4236-9858-D3ECD182C8F4', 'Tidal stream', 'Tidal stream rate and direction / current magnitude and direction and slack water'),
  new FeatureType('6FB8BA41-2205-4BC7-9ADA-668FB9AE14B3', 'Turbidity', 'Turbidity'),
  new FeatureType('A229ED7C-68CC-4427-B6E7-C547F4C7AC7F', 'Visibility', 'Visibility'),
  new FeatureType('F3600346-50D1-446F-A1EF-EA1AF6EB7269', 'Salt', 'Chlorosity, conductivity, water density, salinity'),
  new FeatureType('DC1C23EF-D221-499E-9E5C-540A3E694F79', 'Waves', 'Wave height and wave period'),
  new FeatureType('016654DA-7843-407E-A4D2-30FD3B9B15CD', 'Wind', 'Wind direction, velocity, gust, veering and backing'),
];

export const mockTidalStreamFeatureMetadata: FeatureMetadata[] = [
  {
    attribute: 'Minimum flood direction degrees clockwise',
    value: '330',
  },
  {
    attribute: 'Maximum flood direction degrees clockwise',
    value: '330',
  },
  {
    attribute: 'Distance',
    value: '49',
  },
];

export const mockHeightOfTideFeatureMetadata: FeatureMetadata[] = [
  {
    attribute: 'Conversion NAP to (A)LAT (cm)',
    value: '15',
  },
];

export const mockFeatures: Feature[] = [
  new Feature(
    {
      id: 'B0BDCEC0-FA99-4152-81CD-61C55DDAC277',
      name: 'name',
      description: 'description',
      active: true,
      endDate: '2020-12-31 12:00:00',
      wkid: 210,
      x: 1,
      y: 2,
      z: 3,
      featureType: mockFeatureTypes[6],
      featureMetadata: mockTidalStreamFeatureMetadata,
      processes: undefined,
    }),
  new Feature(
    {
      id: '8A5F308B-18D9-4E50-9172-750170A55458',
      name: 'name',
      description: 'description',
      active: true,
      endDate: '2020-12-31 12:00:00',
      wkid: 210,
      x: 1,
      y: 2,
      z: 3,
      featureType: mockFeatureTypes[0],
      featureMetadata: mockHeightOfTideFeatureMetadata,
      processes: undefined,
    }),
];
